export default {
    loading: "Loading...",
    clientSelector: {
        title: "Switch Client",
        searchPlaceHolder: "Search clients...",
        noResults: "No clients found"
    },
    dataNotFoundError: "The requested page does not exist or could not be loaded.",
    asyncSearchMessage: "Type 3 or more characters and press Enter...",
    terminatedClientModification: "Clients with a terminated status are read-only.",
    inactiveOrTerminatedClientAssociationError: "Unable to associate the user with these clients. The following clients are inactive or terminated: {clients}",
    externalToInternalRoleChangeError: "Cannot change a user role from external to internal.",
    membersArchivedModification: "Archived members cannot be modified.",
    clientArchivedModification: "The information of archived clients cannot be modified.",
    divisionArchivedModification: "The information of archived divisions cannot be modified.",
    classArchivedModification: "The information of archived classes cannot be modified",
    dependentPersonArchivedModification: "The information of archived dependents cannot be modified.",
    noPreviousCoverageForRole: "You are not authorized to create the member's first coverage. Please refer to your account manager.",
    asyncSearchWithoutEnter: "Type 3 or more characters...",
    dtv2ClearFilter: "Empty filters",
    characterCount: "{currentCount} remaining characters",
    pleaseResetFilters:
        "An error has occurred while treating your saved filters, please reset your filters by clicking on the « Empty filters » button.",
    invalidDataFollowUp: "At least one of the selected follow-ups is closed and therefore cannot be modified",
    genericSaveSuccess: "Data has been saved successfully",
    genericSaveError: "An error has occurred while trying to save your information.",
    genericDataFetchError: "An unknown error occurred while fetching data. Please try again later or contact support.",
    pastLastActiveDateError: "Data associated to client cannot be modified or created after its last active date",
    retroactiveLimitError:
        "The data you're attempting to modify is beyond the allowable retroactive limit. Please contact support if you need to make changes.",
    fileNameSpecialCharError:
        "The file name that you are trying to upload contains invalid characters ({invalidChars}), please rename your file.",
    archiveWarning: "WARNING: archiving is definitive and irreversible",
    genericServerError: "A technical error has occurred.",
    allMembersArchivedError: "All selected members are archived or not found and cannot have their files regenerated.",
    allMembersNonEligibleError: "All selected members already have successful recent file regenerations and cannot have their files regenerated again.",
    hint: "Note:",
    importErrors: {
        columnError: "The number of columns in the file is incorrect.{br}{br}Number of columns in the file: {fileNum}.{br}Expected number of columns: {expectedNum}",
        dataTypeError: "A data type error has occurred. Please check the data and make sure you have the latest version of file structure.",
        dataTypeErrorWithValue: "A data type error has occurred for value: {value}. Please check the data and make sure you have the latest version of file structure.",
        dataTypeErrorDivision: "Unknown division: {value}",
        dataTypeErrorClass: "Unknown class: {value}",
        dataTypeLengthError: "The following value exceeds the permitted maximum length: {value}. The maximum allowed length for this field is {length}. Please ensure that this and all other values entered for this field comply with the defined limits.",
        dataTypeErrorCoverage: "Unknown coverage: {value}",
        startDateError: "Start date {startDate} is earlier than billing period start date {billingPeriodStartDate}.",
        endDateError: "End date {endDate} is earlier than start date {startDate}.",
        uniqueNumberError: "The unique number can only contain numbers: {value}.",
        classMissingCoverageError: "The client's class needs at least one coverage: {value}.",
        duplicateMemberError: "Duplicate member identifier: {value}.",
        unknownError: "An unknown error has occurred: {value}.",
        unauthorizedCountryCode: "Please check the authorized countries / provinces in the client form; the following data is not accepted: {country}",
        valueRequiredError: "Import interrupted: an error was detected in the file.{br}First error detected: A value is required, sheet {sheet}, row {row}, column #{column} ({columnName}).{br}Please correct the error and review the entire file before importing again, as other errors may be present.",
    },
    accountingExport: {
        billingPeriod: "Billing Period",
        version: "Downloadable versions",
        payable: "Payable",
        receivable: "Receivable",
        acomba: "Acomba (Standard)",
        acombaDelayed: "Acomba (Delayed)",
        acomba_csv: "Acomba CSV (Standard)",
        acomba_csv_delayed: "Acomba CSV (Delayed)",
        unavailable: "The report you're trying to download is currently unavailable.",
        selectedPeriod: "Selected period",
        warning:
            "The billing period history can be accessed using pagination."
    },
    insurerExport: {
        selectedPeriod: "Selected period",
    },
    versionToggle: {
        fr: "FR Version",
        en: "EN Version",
    },
    toast: {
        visualization:
            "Your invoice is being visualized. Generation may take a few minutes. This message will disappear when generation is complete.",
        generation:
            "Your document is being generated. Generation may take a few minutes. This message will disappear when generation is complete.",
    },
    downloader: {
        acombaExport: "Exporting acomba",
        clientMajorCardExport: "Exporting client's major cards",
        receivable: "Exporting receivables",
        payable: "Exporting payable",
        clientSalaryExport: "Exporting members salary",
        memberMajorCard: "Exporting member(s) major card(s)",
        coverageConfirmations: "Exporting coverage confirmations of client",
        clientReport: "Exporting client report",
        enelReport: "Enel report",
        maximumAge: "Maximum age of dependent persons",
        payroll: "Payroll deductions",
        certificateByCoverage: "Report on certificates by coverage type",
        coverageStatus: "Report on coverage statuses",
        taxBenefit: "Tax benefit reduction",
        insurerExport: "Exporting insurer",
        clientAttachment: "Downloading client attachment",
        suppliersReports: "Downloading suppliers report",
        coverageConfirmation: "Generating coverage confirmation",
        invoiceDownload: "Invoice download",
        eligibilityReport1: "Eligibility report 1",
        eligibilityReport2: "Eligibility report 2",
        premiumReport: "Premium",
        akiraReport: "Telemedecine Model",
        clientExport: "Client export",
        symbility: "Symbility model",
        mondial: "Travel list model",
        provinces: "Provinces",
        divisions: "Divisions",
        weekly: "Weekly",
        biweekly: "Biweekly",
        semiMonthly: "Semi-monthly",
        monthly: "Monthly",
        yearly: "Yearly",
        duplicateDownload: "The file you are trying to download is currently downloading: {br} {file}",
        feus: "FEUS",
        visualizationError: "The invoice that you are trying to download is not completely visualised.",
    },
    admin: {
        title: "Admin",
        blocs: {
            title: "Blocs",
            datatable: {
                actions: {
                    add: "Add Bloc",
                    archiveWarning: "WARNING: archiving is definitive and irreversible. Archiving this Bloc will unassign all clients from it.",
                    edit: "Edit Bloc",
                    includeArchivedBlocs: "Include archived Blocs",
                    showConfirm: {
                        title: "Warning!",
                        message: "If you close now your data will not be saved. Do you want to continue ?",
                        return: "return",
                        continue: "continue",
                    },
                },
                columns: {
                    name: "Name",
                    clientCount: "Number of clients in this Bloc",
                },
            },
            form: {
                name: "Name",
            },
            bloc: {
                pages: {
                    clients: "Clients",
                    settings: "Settings",
                },
                clients: {
                    datatable: {
                        actions: {
                            editButton: "Edit Bloc",
                            editTitle: "Bloc's clients assignation",
                        },
                    },
                    form: {
                        assigned: "Clients assigned to this Bloc",
                        unassigned: "Unassigned clients",
                    },
                },
                settings: {
                    form: {
                        titles: {
                            ledger: "Ledger",
                            taxes: "Insurance Taxes",
                            insurers: "Insurers",
                        },
                        ledgers: {
                            acombaGstNumber: "GST",
                            acombaQstNumber: "QST",
                            acombaHstNumber: "HST",
                            acombaPremiumNumber: "Premium",
                            acombaFeeNumber: "Fee",
                            acombaReserveNumber: "Reserve",
                            acombaReceivableNumber: "Receivable",
                            acombaPayableNumber: "Payable",
                        },
                    },
                },
            },
        },
        accounts: {
            title: "Accounting",
            recievables: {
                title: "Receivables",
                heading: "General ledger receivables accounts ",
                generalAccount: "General accounts receivable",
                insuranceTax: "Insurance taxes receivable",
                salesTax: "Sales tax receivable",
                gst: "GST",
                qst: "QST",
                hst: "HST",
                premium: "Premiums receivable (excluding tax)",
                commissions: "Commission advances",
            },
            payables: {
                title: "Payables",
                heading: "General ledger payables accounts",
                generalAccount: "General accounts payable",
                reservedClients: "Reserved for customers",
                insuranceTaxToPay: "Insurance taxes payable",
                salesTaxToPay: "Sales tax payable",
                gst: "GST",
                qst: "QST",
                hst: "HST",
                majorIncome: "Major Income",
                commissions: "Commissions",
                fees: "Fees",
                markup: "Mark Up",
                premium: "Premiums payable (excluding taxes)",
                brokerCommissions: "Broker commissions",
                insuranceTaxMarkup: "Insurance taxes on mark-up",
                salesTaxMarkup: "Sales tax on mark-up",
            },
            businessunits: {
                title: "Business Units",
                shortTitle: "Units",
                heading: "General ledger business units",
                GM: "Major Group",
                PM: "Major Plan",
            },
        },
        guarantees: {
            title: "Guarantees",
            datatable: {
                actions: {
                    add: "Add guarantee",
                    edit: "Edit guarantee",
                    includeArchivedGuarantees: "Include archived guarantees",
                },
                columns: {
                    name: "Name",
                    shortName: "Abbreviation",
                    code: "Additional Code",
                    category: "Classification",
                    type: "Type",
                },
            },
            form: {
                name: "Name",
                shortName: "Abbreviation",
                code: "Additional Code (if applicable)",
                taxableIncomeFederal: "Federal taxable income",
                taxableIncomeQuebec: "Provincial (Québec) taxable income",
                quebecHealthPremium: "Health Premium (Québec)",
                provincialTaxableBenefits: "Provincial Taxable Benefits (Outside of Québec)",
                type: "Type",
                formula: "Volume / [N] * Rate",
                guaranteeCategory: "Classification",
                dependsOnGuaranteeId: "Depends on",
                dependsOnGuaranteeIdTooltip: "Defines whether this guarantee depends on another. If so, its display and default behaviour, particularly in member coverages, will be affected. This value can be overridden at the client level. This field is disabled if the guarantee is defined as a driving mandatory dependent guarantee or as a mandatory dependent guarantee.",
                isAutomaticallyChecked: "Automatically checked",
                isAutomaticallyCheckedTooltip: "Defines whether this guarantee should be automatically activated based on the member coverage current configuration. For \"Price list\" guarantees that are dependent on another, if this option is checked and the parent guarantee type is defined, they will be activated and will inherit the same type. \"By member\" or \"By member (invoiced rate)\" guarantees cannot be automatically activated. This value can be overridden at the client level.",
                isMandatoryDependentGuarantee: "Mandatory dependent guarantee",
                isMandatoryDependentGuaranteeTooltip: "Defines whether this guarantee concerns dependents and is considered mandatory. If so, its behavior is impacted by the presence and type of its driving guarantees.",
                isDrivingMandatoryDependentGuarantee: "Driving mandatory dependent guarantee",
                isDrivingMandatoryDependentGuaranteeTooltip: "Defines whether this guarantee drives those concerning dependents that are considered mandatory. If so, its presence and type impacts those guarantees. This field is reserved for \"Price list\" type guarantees only. This field is disabled if the guarantee depends on another.",
                errors: {
                    quebecAndOutOfQuebec: "Please choose between Québec or out of Québec",
                    mandatoryAndDriving: "A guarantee cannot be both a mandatory dependent guarantee and a driving guarantee",
                    mandatoryAndMaster: "A mandatory dependent guarantee cannot be a master guarantee",
                    drivingRequiresPriceList: "The \"Driving mandatory dependent guarantee\" field is reserved for \"Price list\" type guarantees only",
                    drivingCannotDependOn: "A driving mandatory dependent guarantee cannot be defined as dependent on another guarantee",
                    dependsOnCannotBeDriving: "A guarantee that depends on another cannot be defined as a driving mandatory dependent guarantee",
                    autoCheckIncompatibleWithMemberTypes: "The \"Automatically checked\" field is not compatible with \"By member\" and \"By member (invoiced rate)\" guarantee types",
                    dependsOnCannotBeMaster: "A parent guarantee cannot be defined as a mandatory dependent guarantee",
                },
            },
            types: {
                fixed: "Fixed",
                list: "Price list",
                formula: "Formula",
                member: "By member",
                memberMultiplier: "By member (invoiced rate)",
            },
            categoryTypes: {
                experience: "Experience",
                mutual: "Mutual",
                other: "Other product",
            },
            modal: {
                clientConfigurationMessageSingular: "This guarantee cannot be set as a driving mandatory dependent guarantee, as it depends on another guarantee in the following client:<br/>",
                clientConfigurationMessagePlural: "This guarantee cannot be set as a driving mandatory dependent guarantee, as it depends on another guarantee in the following clients:<br/>",
                clientConfigurationMessageMandatoryDependentSingular: "This guarantee cannot be set as a mandatory dependent guarantee, as it depends on another guarantee in the following client:<br/>",
                clientConfigurationMessageMandatoryDependentPlural: "This guarantee cannot be set as a mandatory dependent guarantee, as it depends on another guarantee in the following clients:<br/>",
            },
        },
        taxes: {
            title: "Taxes",
            subTitle: "Taxes number",
            datatable: {
                columns: {
                    taxName: "Tax name",
                    taxNumber: "Tax number",
                },
                taxTypes: {
                    insurance: "INSURANCE TYPE",
                },
            },
        },
        insurers: {
            title: "Providers",
            datatable: {
                actions: {
                    add: "Add provider",
                    edit: "Edit provider",
                    includeArchivedInsurers: "Include archived providers",
                },
                columns: {
                    contactFullName: "Administrative contact",
                    emailAddress: "E-mail",
                    insurer: "Provider",
                    phoneNumber: "Phone number",
                },
            },
            form: {
                generalInformation: {
                    title: "General information",
                    name: "Name",
                    address: "Address",
                    city: "City",
                    province: "Province",
                    postalAddress: "Postal address",
                    emergencyPhoneNumber: "Emergency phone number",
                    website: "Website",
                    selfInsured: "Self-insured",
                },
                contacts: {
                    title: "Contacts",
                    adminTitle: "Administrative contact",
                    salesTitle: "Sales contact",
                    fullName: "Name",
                    phoneNumber: "Phone number",
                    emailAddress: "email",
                    language: "Contact language",
                },
                accounts: {
                    title: "Accounting",
                    acombaTitle: "Acomba Configuration",
                    providerNumber: "Provider number",
                },
            },
        },
        brokers: {
            broker: "Broker",
            brokerInformation: "Broker Information",
            adminContact: "Admin Contact",
            phoneNumber: "Phone Number",
            emailAddress: "Email Address",
            actions: "Actions",
            add: "Add",
            addBroker: "Add broker",
            modifyBroker: "Modify Broker",
            fullName: "Full Name",
            generalInformation: "Broker Information",
            identificationNumber: "Identification Number",
            acombaNumber: "Acomba Provider Number",
            affiliatedFirm: "Affiliated Firm",
            contactLanguageCode: "Contact Language",
            type: "type",
            adminEmailAddress: "Email",
            adminContactFullName: "Full Name",
            adminPhoneNumber: "Phone Number",
            adminContactLanguageCode: "Contact Language",
            firm: "Firm",
            modify: "Modify",
            includeArchived: "Include archived brokers",
            compensationType: "Compensation Type",
            calculationTypes: "Calculation Type",
            brokerPart: "Broker's part",
            cashAdvance: "Cash Advance",
            enums: {
                monthly: "Monthly",
                yearly: "Yearly",
                oneTime: "One Time",
                fixed: "Fixed",
                percentage: "Percentage",
            },
        },
        pages: {
            guarantees: "Guarantees",
            insurers: "Providers",
            brokers: "Brokers",
            users: "Users",
            blocs: "Blocs",
            taxes: "Taxes",
            groups: "Client Groups",
        },
        users: {
            title: "Users",
            datatable: {
                actions: {
                    addUser: "Add user",
                    editUser: "Edit user",
                    viewUser: "View user",
                    includeArchivedUsers: "Include archived users",
                },
                columns: {
                    username: "Username",
                    emailAddress: "Email Address",
                    language: "Language",
                    name: "Name",
                    role: "Role",
                    status: "Status",
                    menrolStatus: "Menrol Status",
                },
            },
            form: {
                username: "Username",
                emailAddress: "Email Address",
                firstName: "First Name",
                language: "Interface Language",
                lastName: "Last Name",
                password: "Password",
                role: "Role",
                RoleInternal: "Internal roles",
                RoleExternal: "External roles",
                businessAccount: "Business unit",
                associatedClientId: "Clients",
                phone: "Phone",
                mfa: "MFA code reception preference",
                resetPassword: "Reset the password",
                menrolAccess: "Grant MENROL access",
                clientUserCreationNote:
                    "Please ensure that the plan administrator user account you wish to create does not exist already nor associated with another client. If it's the case, please edit existing user account. Otherwise, duplicate account will be created.",
                confirmationTitle: "Warning!",
                passwordResetConfirmation:
                    "If you request a password reset for the user, a notification will be sent to the following email address {email}. Would you like to continue?",
                successTitle: "Information",
                userCreationSuccess:
                    "The user {userName} has been successfully created and a notification with his login information has been sent. An automatic follow-up has been opened, it will be closed after the first connection of the user",
                emailChangedConfirmation:
                    "If you change the user's email address, a notification will be sent at {email} to inform him/her about the changes.",
            },
            statuses: {
                active: "Active",
                blocked: "Blocked",
                waiting: "Waiting",
            },
            menrolStatuses: {
                active: "Active",
                inactive: "Inactive",
                nonexistent: "Nonexistent",
            },
            types: {
                phone: "By application",
                email: "By email",
                noMFA: "No MFA",
            },
            errors: {
                administratorRoleCreateError: "You are not authorized to create a technical administrator account.",
                administratorRoleUpdateError: "You are not authorized to update a role account to technical administrator."
            }
        },
        groups: {
            title: "Client Groups",
            datatable: {
                actions: {
                    add: "Add client group",
                    edit: "Edit client group",
                    view: "View client group",
                    archiveWarning: "WARNING: archiving is definitive and irreversible. Archiving the client group will remove all clients from it.",
                    includeArchivedGroups: "Include archived client groups",
                },
                columns: {
                    name: "Name",
                    createdBy: "Created by",
                    createdAt: "Created on",
                },
            },
            form: {
                name: "Client group name",
            },
        },
    },
    app: {
        title: "Major System",
    },
    archiveButton: {
        modal: {
            title: {
                archive: "Archiving!",
                delete: "Deleting!",
                unarchive: "Unarchiving!",
            },
        },
        confirmationMessage: {
            archive: "Are you sure you would like to archive {archivedName}?",
            delete: "Are you sure you would like to delete {archivedName}?",
            unarchive: "Are you sure you would like to unarchive {archivedName}?",
        },
        warningMessage: {
            guarantees:
                "WARNING: archiving is definitive and irreversible. If a customer has a coverage price with this guarantee, this could create significant problems in the billing system and in the members' coverages.",
            insurers:
                "WARNING: archiving is definitive and irreversible. If a customer has a coverage price with this provider, this could create significant problems in the billing system and in the members' coverages.",
            clientCoverages:
                "WARNING! If a class of the customer has this coverage price, this could create significant problems in the billing system and in the members' coverages.",
            clientClasses:
                "WARNING! If a member has a coverage with this class, this could create significant problems in the billing system and in the members' coverages.",
            clientsAssociated: "WARNING! This user is linked to the client/clients below.",
        },
    },
    attachments: {
        attachmentLabel: "Attachments",
        attachmentListEmpty: "No attachments",
        attachmentDescription: "Drop the file you wish to upload here",
        attachmentWarning: "File name cannot exceed {length} characters.",
    },
    audit: {
        title: "Internal Audit",
        datatable: {
            columns: {
                date: "Date",
                user: "User",
                action: "Action",
                page: "Details",
            },
        },
        actions: {
            read: "Display",
            create: "Create",
            update: "Modify",
            remove: "Remove",
            cancel: "Cancel",
            generate: "Generate",
            generateFail: "Failed to generate",
            login: "Log in",
            exportedToAcomba: "Exported to Acomba",
        },
        filters: {
            user: "User",
            startDate: "Start date",
            endDate: "End date",
            allUsers: "All users",
        },
        pageName: {
            accountReceivables: "Account Receivables",
            beneficiary: "Beneficiaries",
            billingPeriod: "Billing Period",
            bloc: "Blocs",
            broker: "Broker",
            changePassword: "Change Password",
            class: "Class",
            client: "Client",
            clientAttachment: "File repository",
            clientCoverage: "Coverage Pricing",
            clientExport: "Export list",
            clientImport: "Import list",
            clientSalaryExport: "Export salaries list",
            clientSalaryImport: "Import salaries list",
            configurations: "Configurations",
            accountRecievables: "Account recievables",
            accountPayables: "Account payables",
            accountBusinessUnits: "Account business units",
            connection: "Log in",
            dependentPerson: "Dependent Person",
            dependentPersonCoverage: "Dependent Person Coverage",
            division: "Division",
            guarantee: "Guarantee",
            insurer: "Insurer",
            invoice: "Invoice",
            invoiceExport: "Export Invoices",
            invoiceExportMany: "Export Multiple Invoices",
            member: "Member",
            memberCoverage: "Member Coverage",
            processSync: "Members synchronization",
            user: "User",
            taxes: "Tax management",
            confirmCoverage: "Coverage Confirmation",
            insurerExport: "Export Insurers",
            coveragePeriod: "Coverage Periods",
            clientHistories: "Client History",
            generateMajorCard: "Major card generation",
            generateMajorCardSending: "Request to generate and send Major card",
            memberCreation: "Member creation",
        },
    },
    billing: {
        title: "Billing",
    },
    billingPeriods: {
        title: "Billing periods",
        datatable: {
            actions: {
                add: "Add billing period",
                edit: "Edit billing period",
                view: "View billing period",
                addConfirmationTitle: "Please confirm your entries",
                addConfirmationMessage:
                    "<p>The billing periods cannot be modified or archived after creation. Please confirm the following information before submitting.</p>" +
                    "<p><strong>Name: </strong> {name}</p>" +
                    "<p><strong>Start date: </strong> {startDate}</p>" +
                    "<p><strong>End date: </strong> {endDate}</p>" +
                    "{billingPeriodType, select, RECURRING {} other {" +
                    "{isBillable, select, false {} other {" +
                    "<p><strong>Frequency of adjustment invoices (in months): </strong> {creditsInvoiceFrequency}</p>" +
                    "<p><strong>Number of adjustment invoices: </strong> {creditsInvoiceCount}</p>" +
                    "}}" +
                    "}}" +
                    "<p><strong>Withdrawal period: </strong> {withdrawalPeriod, select, NONE {None} other {{withdrawalPeriod}}}</p>" +
                    "{withdrawalPeriod, select, NONE {} other {" +
                    "<p><strong>Preserve coverages for period: </strong> {preserveCoverages, select, NONE {None} other {{preserveCoverages}}}</p>" +
                    "}}" +
                    "<p><strong>Delay billing generation: </strong> {isDelayed, select, true {Yes} false {No}}</p>",
            },
            columns: {
                name: "Name",
                creation: "Creation",
                startDate: "Start date",
                endDate: "End date",
                withdrawalPeriod: "Withdrawal period",
                withdrawalPeriodStatus: {
                    closed: "Closed",
                    notAvailable: "N/A",
                    open: "Open",
                },
            },
        },
        form: {
            makeRecurring: "Recurring billing period (monthly)",
            name: "Name",
            startMonth: "Starting month",
            startDate: "Start date",
            endDate: "End date",
            hasWithdrawalPeriod: "Withdrawal period",
            startWithdrawalDate: "Withdrawal period start",
            endWithdrawalDate: "Withdrawal period end",
            preservePreviousCoverages: "Preserve a previous period's coverages",
            billingPeriodToPreserve: "Period to preserve",
            isDelayed: "Delay bill generation",
            creditsInvoiceFrequency: "Frequency of adjustment invoices (in months)",
            creditsInvoiceCount: "Number of adjustment invoices",
            description:
                "This page allows you to configure the parameters for generating adjustment invoices. By default, these values are those from the client configuration.\
            The legal deadline for taking into account a billing period adjustments is {year} years. You must enter the monthly frequency for generating adjustment invoices over these {year} years.",
            calculatedInformation:
                "An adjustment invoice will be generated every {frequency} month(s).<br />{invoiceCount} adjustment invoices will be generated over {year} years.",
            warnings: {
                isDelayed:
                    "Once the billing delay option is checked and confirmed, you will not be able to change it for this billing period.",
                withdrawalOrOtherWithdrawal:
                    "The client may choose to have withdrawal by session or annual and/or permanent withdrawal.",
                hasSessionWithdrawal:
                    "The client has opted for withdrawn by session therefore cannot have related billing period",
                relatedBillingPeriod:
                    "Impossible to enable session withdrawal : the client has a related billing period with a withdrawal period for the future",
            },
            error: {
                startDateAfterLastActiveDate:
                    "The billing period start date must be before the client's last active date.",
                endDateAfterLastActiveDate:
                    "The billing period end date must be not later than the client's last active date.",
                startDateAfterCurrentDate: "The billing period start date cannot be in the past",
            },
        },
        types: {
            manual: "Manual (Student Association model)",
            recurring: "Recurring monthly (Corporate model)",
        },
    },
    bulkSalaries: {
        exportSalaries: {
            title: "Step 1: Current salaries export",
            confirmation: {
                title: "Confirmation",
                message: "Please review and confirm the following:",
                fileName: "File name",
            },
            form: {
                button: "Export members salaries",
                exporting: "Exporting",
                generated: "Generating",
            },
        },
        importSalaries: {
            confirmation: {
                title: "Confirmation",
                message: "Please confirm the following import information:",
                fileName: "File name",
            },
            title: "Step 2: New salaries import",
            form: {
                button: "Import",
                effectiveDate: "Effective date",
                file: "File",
                fileDesc: "Drop the file you wish to upload here",
                importing: "Importing",
            },
            messages: {
                error: "An error occurred during the salary importation:",
                success: {
                    generic: "The salary importation was completed successfully.",
                    errors: " with errors",
                    modified: " modified.",
                    skipped: " skipped.",
                    linkText: "{number} {number, plural, one {member} other {members}}",
                    modal: {
                        errors: {
                            title: "Members with import errors",
                        },
                        modified: {
                            title: "Modified members",
                        },
                        skipped: {
                            title: "Skipped members",
                        },
                    },
                },
            },
        },
    },
    clientAttachments: {
        modal: {
            fileDepositWarning:
                "You have 5 minutes to upload the file. In case of error, please close the popup and try again.",
        },
        datatable: {
            actions: {
                add: "Add attachments",
            },
            columns: {
                createdAt: "Date",
                createdBy: "Added By",
                attachmentName: "File name",
            },
        },
    },
    clients: {
        title: "Clients",
        invalidClientIdType: "The client ID you provided is invalid.",
        unauthorizedRedirectedExternalUser: "You don't have access to the data you tried to visualize. If you believe this is an error, please contact support",
        autoSaveActiveWarning: "Changes made to this field are automatically saved.",
        synchronizedWith: "Synchronization via {syncType, select, TED_DESJARDINS {TED Desjardins} ELIGIBILITY {Telus Adjudicare}}",
        activationInfo: "The status change from MEV to <span class='green'>ACTIVE</span> of the client {client} was <span class='green'>successful</span>. The next billing period is <span class='text-capitalize blue'>{bp}</span>, with retroactive invoices for the following billing periods: <br/><br/>",
        synchronizationStatus: {
            nonSyncClient: "The client is not synchronizable.<br/><br/>1- The client must not have a terminated status.<br/><br/> 2- The client must not be archived.<br/><br/>3- The client must have a valid choice of API synchronization.",
            success: "Client’s information is synchronized",
            inProgress: "Client information synchronization is in progress",
            failed: "Client information has failed to synchronize",
            notSynced: "Client information is not synchronized",
            notSynchronizable: "Client information is not synchronizable"
        },
        clientTypes: {
            brokerage: "Brokerage",
            tpa: "TPA",
            tpp: "TPP",
            aso: "ASO"
        },
        datatable: {
            actions: {
                add: "Add client",
                edit: "Edit client",
                view: "View client",
                includeArchivedClients: "Include archived clients",
                showOnly: "Display only",
                showConfirm: {
                    title: "Warning!",
                    message: "If you close now your data will not be saved. Do you want to continue?",
                },
            },
            columns: {
                billingPeriods: "Billing periods",
                client: "Client",
                fullName: "Full name",
                name: "Name",
                creationDate: "Creation date",
                type: "Insurance type",
                status: "Status",
            },
            toolTips: {
                syncToolTipArchived: "Archived clients are not synchronizable.",
                syncToolTipWarning: "The client is not synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTip: "The client is synchronized.",
                syncToolTipStarted: "The synchronization of the client is in progress."
            },
        },
        followUps: {
            form: {
                contact: "Preferred client contact",
            },
        },
        form: {
            inactivationReasons: {
                boughtByClientOutsideMajor: "Bought by client outside Major",
                boughtByMajorClient: "Bought by Major client",
                leavingForCompetitor: "Leaving for competitor",
                noLongerOffersGroupInsurance: "No longer offers group insurance (too expensive)",
                eligibilityCriteriaTooSmall: "Eligibility criteria (group too small)",
                death: "Death",
                bankruptcy: "Bankruptcy",
                other: "Other",
            },
            additionalConfigurations: {
                title: "Additional Configurations",
                tedDesjardins: "TED Desjardins",
                showDependentPersonFormula:
                    "Add a line explaining the formula behind the policyholder's premium amount on the <strong class='emphasis'>coverage confirmation</strong>",
                shouldImportWithoutId: "<strong class='emphasis'>Major Code</strong> recovery management",
                excludeNotifications: "Exclude notifications of invoice publications",
                includeNotifications: "Include this customer in invoice publication notifications",
                isAutomaticMemberIdentifier: "Unique number configuration for members",
                automaticOption: "Automatic",
                isSyncEligible: "Choice of API synchronization",
                eligibility: "TELUS-ADJUDICARE",
                noSync: "No API synchronization",
                manualOption: "Manual",
                admin: "Administrator",
                fintech: "Fintech",
                defaultLength: "Default length",
                customLength: "Custom length",
                memberIdentifierLength: "Length for unique number",
                accountTypeSelection:
                    "The account type must be selected to get the option to choose member generation method",
                clientNumberExists:
                    "The client with the entered client number exists in the system. Therefore, the existing method for member generation will be used.",
                syncTypeWarning:
                    "Please note that if you choose this synchronization, the client will be automatically created in the selected partner, his information will then be synchronized automatically. You cannot change this value after the client is created.",
                tedSyncWarning: "Please note that if you choose this synchronization, you have to make sure this client already exists in Desjardins system. Once ACTIVE, his information will then be synchronized via TED. You cannot change this value after the client is created.",
            },
            block: {
                title: "Block Attribution",
            },
            complement: {
                title: "Complement",
                groupLabel: "Client Group",
            },
            payment: {
                title: "Receivables",
            },
            acombaSettings: {
                acombaNumber: "Client number (ACOMBA)",
                acombaProjectNumber: "Project number",
                title: "Acomba configuration",
            },
            client: {
                bloc: "Bloc",
                clientType: "Type of client",
                noBlocs: "No Blocs",
                designator: "Acronym",
                billingPeriods: "Billing periods",
                coverageWebsite: "Coverage URL",
                name: "Usual name",
                fullName: "Full name",
                status: "Status",
                title: "Client information",
                type: "Insurance type",
                ratePeriodType: "Rate configuration",
                planInactive: "Schedule the client's inactive passage",
                planInactiveEndDate: "Last day of activity",
                planInactiveCancel: "Cancel client's inactivity",
                planInactiveComplement: "Specify",
                planInactiveReason: "Inactivity reason",
                planInactiveReasonComplement: "Complement",
                planInactiveSuccess: "The client's inactivation planification was saved",
                planInactiveCancelSuccess: "The client's inactivation planification was canceled",
                planInactiveCancelProcess: "The cancelation of the client's scheduled inactivation is in progress and may take a few seconds to complete.",
                broker: {
                    associatedBrokerLimit: "Limit 5 brokers per client",
                    loading: "Brokers loading...",
                },
                paymentmode: "Payment mode",
                accountType: "Account type",
                inactivePassageModalTitle: "INACTIVE passage of client",
                inactivePassageModalInfo:
                    "To pass the client INACTIVE you need to fill in the following information.{br}The client's last day of activity can be a date in the future up to 3 months after the current date.{br}" +
                    "Proceed with caution: this client will be excluded from the billing process altogether after its inactivation date (except termination invoice).",
            },
            enum: {
                cheque: "Cheque",
                transfer: "Transfer",
                preauthorized_debit: "Preauthorized Debit",
                gm: "Groupe Major",
                pm: "Plan Major",
            },
            sections: {
                generalInformation: "General informations",
                accounting: "Accounting",
                configuration: "Configuration",
                associatedBrokers: "Associated brokers",
                coveragePeriods: "Coverage period",
            },
            majorCost: {
                title: "Major Cost",
                fixedFees: "Fixed Fees",
                variableFees: "Fees per member",
            },
            civicAddress: {
                title: "Civic address",
                address: "Address",
                city: "City",
                country: "Country",
                provinceCode: "Province",
                postalCode: "Postal Code",
                phoneNumber: "Phone number",
                PMSalesTaxesInformations: "The client's province determines the applicable tax rate for billing",
            },
            otherInformation: {
                effectiveDate: "Effective Date",
                renewalDate: "Renewal Date",
                terminationDate: "Termination",
                clientNumber: "Client number (Telus or Desjardins)",
                clientNumberHeader: "Client number",
                shortClientNumber: "Number",
                accountManager: "Account Manager",
                shortAccountManager: "Manager",
                serviceRepresentative: "Service Representative",
                shortServiceRepresentative: "Representative",
                select: "Select",
                lastMemberGenerated: "Last member created",
                member: "Member",
                uniqueNumber: "Unique number",
                createdBy: "Created by",
                createdOn: "Creation Date",
                createdAt: "Creation Time",
                division: "Division",
                status: "Status",
                role: "Role",
            },
            coveragePeriods: {
                title: "Coverage Period",
                startDate: "Start date",
                endDate: "End date",
                renew: "Renew",
                renewCoverage: "Renew coverage period",
                durationWarning: "Warning, the coverage period duration is less than 1 year.",
            },
        },
        client: {
            errors: {
                fetchingError: "Unable to retrieve client information.",
            },
            categorisation: {
                saveBtn: "Save",
                cancelBtn: "Cancel",
                categoryForm: {
                    title: "Classification of the client",
                    clientCoveragesRedirection: "Details of coverage prices",
                    form: {
                        missingFieldsError: "One or more mandatory fields are missing. Please verify the form.",
                        clientType: "Client type",
                        provenance: "Provenance",
                        brokerName: "Broker's name",
                        reference: "Reference",
                        requirementLevel: "Service requirement level",
                        notoriety: "Notoriety",
                        vipClient: "VIP Client",
                        vipClassification: "VIP Classification",
                        retirementPlan: "Retirement plan",
                        currentAssets: "Current assets",
                        insurers: "Insurer(s)",
                        numberOfMembers: "Number of ACTIVE members",
                        seller: "Seller name",
                        clientTypes: {
                            brokerage: "Brokerage",
                            tpa: "TPA",
                            tpp: "TPP",
                            aso: "ASO",
                        },
                        provenanceTypes: {
                            direct: "Direct",
                            acquired: "Acquired",
                            broker: "Broker",
                            brokerName: "Broker's name",
                            reference: "Reference",
                        },
                        requirementLevelTypes: {
                            low: "Low",
                            medium: "Medium",
                            high: "High",
                        },
                        notorietyTypes: {
                            supplier: "Provider",
                            partner: "Partner",
                            acquaintance: "Acquaintance",
                            foreign: "Stranger",
                        },
                        vipClassificationTypes: {
                            premiumSize: "Premiums size",
                            partner: "Partner",
                            network: "Network",
                            acquaintance: "Acquaintance",
                        },
                        retirementPlanTypes: {
                            yes: "Yes",
                            no: "No",
                            prospect: "Prospect",
                        },
                        currentAssetTypes: {
                            lessThan250: "< 250 000",
                            between250And1m: "250 000 to 1 000 000",
                            moreThan1m: "1 000 000 +"
                        },
                        insurerTypes: {
                            multiInsurers: "Multi-Insurers",
                            noInsurers: "No insurer",
                        },
                    },
                },
                financialForm: {
                    title: "Financial value",
                    form: {
                        numberOfActiveMembers: "Number of ACTIVE members",
                        segmentation: "Segmentation",
                        marketSituation: "Market situation",
                        segmentationTypes: {
                            highIncome: "A - High-income client",
                            middleIncome: "B - Middle-income client",
                            lowIncome: "C - Low-income client",
                            notBillable: "Non-billable client"
                        },
                        marketSituationTypes: {
                            growth: "Growth",
                            stable: "Stability",
                            decrease: "Decrease",
                            danger: "Danger",
                            forSale: "For sale",
                            termination: "Termination",
                        },
                    },
                },
                otherForm: {
                    title: "Other information",
                    form: {
                        note: "Note",
                    },
                },
            },
            personalDataConfig: {
                title: "Personal data form configuration",
                personalData: "Personal data",
                subTitle:
                    "Tick the personal information that will appear on the form and that the participant will be able to check",
                form: {
                    createForm: "Create a personal data review form",
                    hasPersonalDataFormMessage: "Display a custom message above the form",
                    hasPersonalDataPopupMessage:
                        "Display an information popup after email verification code validation",
                    firstName: "First name",
                    lastName: "Last name",
                    phoneNumber: "Phone number",
                    email: "Email",
                    birthDate: "Birth date",
                    gender: "Gender",
                    language: "Language",
                    address: "Address",
                    city: "City",
                    country: "Country",
                    province: "Province",
                    postalCode: "Postal Code",
                    formVisualization: "Visualize the form",
                    formAccess: "Access the form",
                    postalAddress: "Postal address",
                },
            },
            pages: {
                members: "Members",
                billingPeriods: "Billing periods",
                classes: "Classes",
                divisions: "Divisions",
                clientGuarantees: "Guarantee Configuration",
                coverages: "Price of coverages",
                invoices: "Invoices",
                configurations: "Configurations",
                withdrawal: "Withdrawal form",
                personalData: "Personal data",
                invoicingConfig: "Adjustments",
                classification: "Classification",
                contacts: "Contacts",
                memberIdentifier: "Major Code recovery",
                reports: "Reports",
                messages: "Messages",
                clientAttachments: "File repository",
                bulkSalary: "Salaries modification",
                premiumSimulator: "Premium Simulator",
                clientUsers: "Client users",
                synchronizations: "Synchronizations",
                memberFiles: "Failed file generations",
                majorEnrolment: "Major enrolment",
            },
            premiumSimulator: {
                form: {
                    multipleCoverageTypeSelection: "You have selected different guarantee coverage types in this simulation. Please ensure that this configuration is compatible with the insurance contract.",
                    noClassSelection: "Please choose a class or member to view guarantees",
                    birthdate: "Birthdate",
                    classId: "Class",
                    divisionId: "Division",
                    employeeType: "Employee Type",
                    employeeTypes: {
                        new: "New",
                        existing: "Existing",
                    },
                    generate: "Generate",
                    employeeDetails: "Employee Information",
                    firstName: "First Name",
                    language: "Language",
                    lastName: "Last Name",
                    member: "Employee",
                    memberCoverageType: "Coverage Type",
                    payrollFrequency: "Pay Frequency",
                    provinceCode: "Province",
                    salary: "Annual Salary",
                    select: "Select...",
                },
                payrollFrequencyTypes: {
                    WEEKLY: "52 pay periods",
                    BIWEEKLY: "26 pay periods",
                    SEMIMONTHLY: "24 pay periods",
                    MONTHLY: "Monthly",
                    ANNUAL: "Annual",
                },
                locales: {
                    "fr-CA": "French",
                    "en-CA": "English",
                },
                results: {
                    results: "Simulation Results",
                    certificate: "Certificate",
                    date: "Simulation Date",
                    error: "An error occurred.",
                    export: "Export",
                    parameters: "Simulation Parameters",
                    print: "Print",
                    summary: {
                        annual: "Annual Summary",
                        monthly: "Monthly Summary",
                        payPeriod: "Summary per Pay Period",
                        employeePart: "Employee Cost",
                        employerPart: "Employer Cost",
                        subtotal: "Subtotal",
                        taxes: "Taxes",
                        total: "Total",
                    },
                    details: {
                        annual: "Annual Details",
                        monthly: "Monthly Details",
                        payPeriod: "Details per Pay Period",
                        description: "Description",
                        employeePart: "SAL",
                        employerPart: "EMP",
                        cost: "Cost",
                        taxes: "Taxes",
                        subtotals: "Subtotals",
                        total: "TOTAL",
                    },
                    payrollDeductions: {
                        payrollDeductions: "Payroll Deductions & Taxable Benefits",
                        taxableBenefitsProvincial: "Taxable Benefits (Provincial)",
                        taxableBenefitsFederal: "Taxable Benefits (Federal)",
                        salaryDeductions: "Salary deductions",
                        lifeInsurance: "Life Insurance",
                        groupInsurance: "Group Insurance",
                        quebecHealthInsurance: "Health (QC)",
                        quebecHealthPremium: "Health Premium (QC) / Box 85",
                    },
                },
            },
            reports: {
                form: {
                    type: "Type",
                    generate: "Generate",
                    generating: "Generating",
                    languageCode: "File language",
                },
                taxBenefits: {
                    title: "Tax benefits reduction",
                    form: {
                        startingBillingPeriod: "Starting billing period",
                        endingBillingPeriod: "Ending billing period",
                    },
                },
                coverageCertificate: {
                    title: "Report on certificates by coverage type",
                    form: {
                        billingPeriod: "Billing period",
                        formatType: "Format",
                        type: {
                            province: "Provinces",
                            division: "Divisions",
                        },
                    },
                },
                coverageStatuses: {
                    title: "Report on coverage statuses",
                    form: {
                        billingPeriod: "Billing period",
                    },
                },
                dependentPersonCoveragesTerminations: {
                    title: "Maximum age of dependent persons",
                    form: {
                        billingPeriod: "Billing period",
                    },
                },
                ENELReport: {
                    // Eligigle Non-Evidence Limit
                    title: "ENEL report",
                },
                payrollDeductions: {
                    title: "Payroll Deductions",
                    form: {
                        format: "Format",
                        WEEKLY: "Weekly",
                        BIWEEKLY: "Biweekly (26 pay periods)",
                        SEMIMONTHLY: "Semi-monthly (24 pay periods)",
                        MONTHLY: "Monthly",
                        ANNUAL: "Yearly",
                        ANNUAL_WITH_CREDITS: "Annual with credits",
                        MONTHLY_WITH_CREDITS: "Monthly with credits",
                        year: "Year",
                    },
                    validBilingPeriodsWarning: "Please ensure the client has billing periods and valid invoices, as reports cannot be generated for TEMPLATE invoices.",
                    validBilingPeriodsWarningPA: "At least one invoice is required for this type of report.",
                },
                header: {
                    warningMessage:
                        "Please note that the billing period {billingPeriod} is not completed. The values of these reports may change.",
                },
            },
            withdrawalPeriods: "Withdrawal {periods, plural, one {period} other {periods}}",
            processSync: {
                notificationsBoard: {
                    title: "Synchronization logbook",
                    details: {
                        titles: {
                            adjudicareSynchronization: "Adjudicare synchronizations"
                        },
                        messages: {
                            notificationSyncSuccessParticipant: "Information for member {member} is synchronized in Telus Adjudicare",
                            notificationSyncFailParticipant: "Information for member {member} is not synchronized in Telus Adjudicare",
                            notificationSyncInProgressParticipant: "Information for member {member} is currently being synchronized in Telus Adjudicare",
                            notificationSyncSuccessPAC: "Information for dependent {PAC} is synchronized in Telus Adjudicare",
                            notificationSyncFailPAC: "Information for dependent {PAC} is not synchronized in Telus Adjudicare",
                            notificationSyncInProgressPAC: "Information for dependent {PAC} is currently being synchronized in Telus Adjudicare",
                            notificationSyncSuccessDivision: "Information for division {division} is synchronized in Telus Adjudicare",
                            notificationSyncFailDivision: "Information for  division {division} is not synchronized in Telus Adjudicare ",
                            notificationSyncInProgressDivision: "Information for  division {division} is currently being synchronized in Telus Adjudicare",
                            notificationSyncSuccessClient: "Information for client {client} is synchronized in Telus Adjudicare",
                            notificationSyncFailClient: "Client information for {client} is not synchronized in Telus Adjudicare",
                            notificationSyncInProgressClient: "Client information for {client} is currently being synchronized in Telus Adjudicare",
                            notificationSyncSuccessClass: "Information for class {class_} is synchronized in Telus Adjudicare",
                            notificationSyncFailClass: "Information for class {class_} is not synchronized in Telus Adjudicare",
                            notificationSyncInProgressClass: "Information for class {class_} is currently being synchronized in Telus Adjudicare",
                        },
                        messagesWithUsers: {
                            notificationSyncSuccessParticipant: "Information for member {member} is synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncFailParticipant: "Information for member {member} is not synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncInProgressParticipant: "Information for member {member} is currently being synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncSuccessPAC: "Information for dependent {PAC} is synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncFailPAC: "Information for dependent {PAC} is not synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncInProgressPAC: "Information for dependent {PAC} is currently being synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncSuccessDivision: "Information for division {division} is synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncFailDivision: "Information for  division {division} is not synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncInProgressDivision: "Information for  division {division} is currently being synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncSuccessClient: "Information for client {client} is synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncFailClient: "Client information for {client} is not synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncInProgressClient: "Client information for {client} is currently being synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncSuccessClass: "Information for class {class_} is synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncFailClass: "Information for class {class_} is not synchronized in Telus Adjudicare following a modification carried out by {user}",
                            notificationSyncInProgressClass: "Information for class {class_} is currently being synchronized in Telus Adjudicare following a modification carried out by {user}",
                        }
                    },
                    actions: {
                        seeMore: "See more",
                        reload: "Recharge"
                    },
                    filters: {
                        onlyMyModifications: "See only my changes",
                        onlyErrors: "See only errors"
                    },
                },
                form: {
                    synchronize: "Synchronize",
                    syncSentSuccess: "Synchronization has been launched.",
                    syncSentFailure: "Synchronization could not be started.",
                    fetchingWarningsMessage: "Verifying...",
                    warnings: {
                        dependentPersonCoverageOverlapWarning: "One or more dependent coverages associated with this billing period may have been made identical to other related coverages. The synchronization could result in overlapping coverages in Adjudicare, preventing the claims. Before starting the synchronization, please make sure the following coverage dates are compatible with Adjudicare. Clicking Confirm will start an Adjudicare synchronization.",
                        memberCoverageOverlapWarning: "One or more member coverages associated with this billing period may have been made identical to other related coverages. The synchronization could result in overlapping coverages in Adjudicare, preventing the claims. Before starting the synchronization, please make sure the following coverage dates are compatible with Adjudicare. Clicking Confirm will start an Adjudicare synchronization."
                    }
                },
                datatable: {
                    title: "Synchronizations",
                    statusTypes: {
                        init: "Initialized",
                        started: "Started",
                        success: "Success",
                        failure: "Failure",
                        incomplete: "Incomplete",
                    },
                    billingPeriod: "Billing period",
                    status: "Status",
                    memberSynchronizedCoverages: "Synchronized member coverages",
                    dependentSynchronizedCoverages: "Synchronized dependent coverages",
                    startedAt: "Start date",
                    duration: "Duration",
                },
                errorIdentifiers: {
                    unidentifiedCommunicationError:
                        "A communication error has occurred with Telus. It may be caused by an overload of their service. Please wait a few minutes before starting a new synchronization. If the problem persists, please contact support.",
                    connectionAborted:
                        "A Telus error has occurred. It may be caused by an overload of their service. Please wait a few minutes before starting a new synchronization.",
                    unexpectedError: "An unidentified Telus error has occurred.",
                    certUnidentifiedError: "A configuration analysis is required for the member{memberIdentifier, select, NONE {} other {: }}{memberIdentifier, select, NONE {} other {{memberIdentifier}}}.",
                    certMemberIdentifierTrailingZerosError: "The member identifier {memberIdentifier} already exists in Adjudicare. The numbers having trailing zeros are considered identical to those without zeros. (for example, \"00532\" is identical to \"532\").",
                    certUnexpectedError: "An unidentified Telus error has occurred for member {memberIdentifier}.",
                    certInvalidCertNumber: "A member with identifier {memberIdentifier} already exists.",
                    certInvalidDivNumber:
                        "Division with number {elementId} does not exist in Telus for member {memberIdentifier}.",
                    certInvalidClassNumber:
                        "Class with number {elementId} does not exist in Telus for member {memberIdentifier} or is not found for the associated division.",
                    certInvalidPostalCode: "Postal code for member {memberIdentifier} is invalid.",
                    certMemberIdentifierSpace: "The identifier of member {memberIdentifier} has a space. Please correct their identifier.",
                    certMissingAddressElement:
                        "Address for member {memberIdentifier} is invalid. Please check address, city and postal code information.",
                    certInvalidDate: "Information {field} is invalid for member {memberIdentifier}. Future birthdate is not accepted by Telus.",
                    certInvalidTerminationDate:
                        "Coverage end date for member {memberIdentifier} cannot be before its start date.",
                    certMissingBirthdate: "Birthdate for member {memberIdentifier} must be entered.",
                    certMissingClientNumber: "The client number (Telus) for member {memberIdentifier} is not filled.",
                    certInvalidClientNumber: "The client number (Telus) for member {memberIdentifier} is invalid.",
                    certInvalidCoverageStartDate:
                        "The member {memberIdentifier} has a coverage with a start date that's prior to the start date of the Telus class.",
                    certMissingProvince: "Province for member {memberIdentifier} is not filled.",
                    certMissingCountry: "Country for member {memberIdentifier} is not filled.",
                    certWrongCertNumber:
                        "Member identifier of member {memberIdentifier} contains invalid characters (special characters or accents).",
                    certInvalidBankCode: "The bank institution number of member {memberIdentifier} is invalid.",
                    certInvalidEffectiveDate: "The start date of the coverage for member {memberIdentifier} is invalid.",
                    certInvalidAccountNumber: "The banking account number of member {memberIdentifier} is invalid.",
                    certInvalidBranchNumber: "The transit number of member {memberIdentifier} is invalid.",
                    certMissingBankCode: "The bank institution number of member {memberIdentifier} is not filled.",
                    certMissingAccountNumber: "The bank account number of member {memberIdentifier} is not filled.",
                    certMissingBranchTransitNumber: "The transit number of member {memberIdentifier} is missing.",
                    certMissingMemberIdentifier: "The member does not have a member identifier.",
                    certInvalidLengthFirstName: "The provided first name exceeds the 50 character limit for Telus synchronization.",
                    certInvalidLengthLastName: "The provided last name exceeds the 50 character limit for Telus synchronization.",
                    certInvalidLengthPhoneNumber: "The provided phone number exceeds the 30 character limit for Telus synchronization.",
                    certInvalidLengthEmailAddress: "The provided email address exceeds the 100 character limit for Telus synchronization.",
                    certInvalidLengthCity: "The provided city exceeds the 50 character limit for Telus synchronization.",
                    certInvalidLengthMemberIdentifier: "The provided member unique number exceeds the 15 character limit for Telus synchronization.",
                    certDivisionNotSynchronized: "The division used for coverage synchronization is not properly synchronized.",
                    certEmptyExternalClassNumber: "The coverage of the member {memberIdentifier, select, NONE {} other {{memberIdentifier}}} {startDate, select, null {} other {starting {startDate} }}is associated to a class that is not synchronized.",
                    invalidDependent: "A dependent of member {memberIdentifier} already exists.",
                    dependentUnexpectedError:
                        "An unidentified Telus error has occurred for a dependent of member {memberIdentifier}.",
                    dependentInvalidPostalCode:
                        "A dependent of member {memberIdentifier} has invalid postal code. Please check the associated member's field.",
                    dependentMissingAddressElement:
                        "A dependent of member {memberIdentifier} has invalid address. Please check address, city and postal code of the associated member.",
                    dependentInvalidDate:
                        "A dependent of member {memberIdentifier} has an invalid date for the field {field}. Future birthdate is not accepted by Telus.",
                    dependentInvalidInfos:
                        "A dependent of member {memberIdentifier} has the same birthdate and first name as another dependent.",
                    dependentMissingBirthdate: "A dependent of member {memberIdentifier} has no birthdate.",
                    dependentInvalidCoverageStartDate:
                        "A dependent person of member {memberIdentifier} has a coverage with a start date that's prior to the start date of the Telus class.",
                    dependentMissingProvince:
                        "Province, used by a dependent, of member {memberIdentifier} is not filled.",
                    dependentMissingCountry:
                        "Country, used by a dependent, of member {memberIdentifier} is not filled.",
                    dependentMissingClientNumber:
                        "The client number (Telus) for a dependent of member {memberIdentifier} is not filled.",
                    dependentMissingDivisionElement:
                        "The dependant's coverage start date is not covered by a member coverage.",
                    dependentInvalidClientNumber:
                        "The client number (Telus) for a dependent of member {memberIdentifier} is invalid.",
                    dependentInvalidDivNumber:
                        "Division with number {elementId} does not exist for a dependent of member {memberIdentifier}.",
                    dependentInvalidCertNumber:
                        "No member with identifier {memberIdentifier} has been found in Telus for a dependent.",
                    dependentInvalidTerminationDate:
                        "Coverage end date for a dependent of member {memberIdentifier} cannot be before its start date.",
                    dependentInvalidEffectiveDate:
                        "Coverage start date for a dependent of member {memberIdentifier} cannot be before the member coverage start date in Telus.",
                    dependentMultipleSpouse: "Member {memberIdentifier} has multiple spouses at the same time.",
                    dependentWrongCertNumber:
                        "Member identifier for a dependent's member is incorrect. Member identifier {memberIdentifier} contains invalid characters (special characters or accents).",
                    dependentMissingMemberIdentifier: "The member identifier associated to the dependent is empty. Please fill in his member identifier.",
                    dependentInvalidLengthMemberIdentifier: "The member identifier ({memberIdentifier}) of the member associated to the dependent exceeds the limit (15 characters). Please correct their member identifier.",
                    dependentMemberIdentifierSpace: "The member identifier ({memberIdentifier}) of the member associated to the dependent has a space. Please correct their member identifier.",
                    dependentInvalidLengthFirstName: "The provided first name exceeds the 50 character limit for Telus synchronization.",
                    dependentInvalidLengthLastName: "The provided last name exceeds the 50 character limit for Telus synchronization.",
                    divisionUnexpectedError: "An unidentified Telus error has occurred.",
                    divisionInvalidEffectiveDate:
                        "The client's start date (the start of the earliest coverage period) differs from the one saved in Telus. Please update it or contact support to get it corrected.",
                    divisionMissingClientNumber:
                        "The client number (Telus) has not been assigned to the client. Please fill it in or contact support to get it corrected.",
                    divisionInvalidClientNumber:
                        "The client number (Telus) {elementId} assigned to the client is invalid. Please update it or contact support to get it corrected.",
                    divisionInvalidDivisionNumber:
                        "The Telus division number {elementId} assigned to the division is invalid. Please update it or contact support to get it corrected.",
                    divisionInvalidLengthDivisionNumber: "The provided Telus division number {elementId} exceeds the 9 character limit for Telus synchronization.",
                    divisionInvalidNonNumericDivisionNumber: "The Telus division number {elementId} contains non-numeric characters.",
                    divisionUnexpectedDivisionId:
                        "The partner division number {elementId} saved in Telus is different from one in system. Please contact support to get it corrected.",
                    divisionNonCanadianProvince:
                        "A non-Canadian province is assigned in client address.",
                    divisionUnidentifiedError: "An unidentified error has occurred.",
                    divisionMissingProvince: "The province for client has not been assigned.",
                    divisionInvalidThirdPartyNumber: "The division number is invalid.",
                    fields: {
                        startDate: "Coverage start date",
                        endDate: "Coverage end date",
                        birthdate: "Birthdate",
                        city: "City",
                        postcd: "Postal code",
                    },
                    clientInvalidLengthCity: "The provided city exceeds the 50-character limit required for Telus synchronization.",
                    clientInvalidLengthName: "The provided client name exceeds the 100-character limit required for Telus synchronization.",
                    clientInvalidLengthAdminContactPhoneNumber: "The provided administrative contact phone number exceeds the 30-character limit required for Telus synchronization.",
                    clientInvalidLengthAdminContactEmailAddress: "The provided administrative contact email address exceeds the 100-character limit required for Telus synchronization.",
                    clientInvalidLengthAdminContactFullName: "The provided administrative contact full name exceeds the 50-character limit required for Telus synchronization.",
                    clientInvalidClientNumber: "The client number is invalid.",
                    clientInvalidInfos: "The client information in field {field} is invalid.",
                    clientInvalidInfosGeneric: "The client information is invalid, please verify it. Contact technical support if the problem persists.",
                    clientMissingName: "The client's name has not been assigned.",
                    clientMissingAddress: "The client's address has not been assigned.",
                    clientMissingCity: "The client's city has not been assigned.",
                    clientMissingPostalCode: "The client's postal code has not been assigned.",
                    clientMissingCountryCode: "The client's country has not been assigned.",
                    clientMissingCoveragePeriodStartDate: "The client's coverage period start date has not been assigned.",
                    clientUnexpectedError: "An unidentified Telus error has occurred.",
                    clientUnidentifiedError: "An unidentified error has occurred.",

                    classUnexpectedError: "An unidentified Telus error has occurred.",
                    classMissingClientNumber: "The client number (Telus) has not been assigned.",
                    classMissingClassNumber: "The class number has not been assigned.",
                    classMissingDivisionNumber: "The Telus division number has not been assigned in the associated division.",
                    classUnidentifiedError: "An unexpected error has occurred. Please ensure that the client and associated division are properly synchronized with Telus. If synchronization is confirmed and the issue persists, contact support for further assistance.",
                    classInvalidEffectiveDate:
                        "The client's start date (the start of the earliest coverage period) differs from the one saved in Telus. Please update it or contact support to get it corrected.",
                },
                coverageStartDateWarning: "This coverage already exists in Adjudicare. Updating the information of the coverage in Telus-Adjudicare may take 24 to 48 hours; claims may be blocked while the update is in process.",
                inProgressSyncs: "Synchronizations in progress",
                synchronize: "Synchronize",
                synchronizedMemberCoverages: "Synchronized member coverages",
                synchronizedDepCoverages: "Synchronized dependent coverages",
                errors: {
                    technicalError: "A technical error has occurred.",
                    processSyncLimitError: "You cannot start more than one synchronization at a time for a client.",
                },
            },
        },
        insuranceStatus: {
            fully: "Fully Insured",
            self: "Self Insured",
        },
        ratePeriodTypes: {
            month: "Monthly",
            billingPeriod: "Per billing period",
        },
        header: {
            group: "Group",
            extension: "extension"
        },
    },
    header: {
        goToV2: "New interface",
    },
    common: {
        blank: " ",
        na: "N/A",
        nd: "N/D",
        add: "Add",
        archive: "Archive",
        unarchive: "Unarchive",
        continue: "Continue",
        cancel: "Cancel",
        close: "Close",
        confirm: "Confirm",
        delete: "Delete",
        download: "Download",
        downloadFinished: "Download finished",
        edit: "Edit",
        editSelection: "Edit selection",
        confirmationWarningTitle: "Warning!",
        showSelectedCheckboxes:
            "{showSelectedCheckboxes} {showSelectedCheckboxes, plural, one {element} other {elements}} selected",
        modifyNumberCheckBoxUsed:
            "Modify selection ({showSelectedCheckboxes}) {showSelectedCheckboxes, plural, one {element} other {elements}}",
        modifySelectionElement:
            " Please note that the changes will be carried over to the {showSelectedCheckboxes, plural, one {} other {{showSelectedCheckboxes}}} selected {showSelectedCheckboxes, plural, one {follow-up} other {follow-ups}}",
        filters: {
            emptyLabel: "No matches found.",
            promptText: "Type to search...",
            searchText: "Searching...",
        },
        generate: "Generate",
        generating: "Generating...",
        loading: "Loading...",
        logout: "Logout",
        reset: "Reset",
        save: "Save",
        select: "Select...",
        noResults: "No results found",
        view: "View",
        yes: "Yes",
        no: "No",
        ok: "Ok",
        toDate: "to",
        month: {
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December",
        },
        provinces: {
            QC: "Quebec",
            ON: "Ontario",
            AB: "Alberta",
            BC: "British Colombia",
            MB: "Manitoba",
            NB: "New Brunswick",
            NL: "Newfoundland and Labrador",
            NS: "Nova Scotia",
            NT: "Northwest Territories",
            NU: "Nunavut",
            PE: "Prince Edward Island",
            SK: "Saskatchewan",
            YT: "Yukon",
        },
        year: "{number} Year",
        months: "{number} Months",
        weeks: "{number} Weeks",
        unknown: "Unknown",
        reservedField: "This field is reserved to Groupe Major",
        options: "Options",
        optional: "(Optional)",
        logoutError: "An error has occurred while logging out. Please contact support.",
    },
    configurationsForm: {
        configurations: "Configurations",
        authorizationCode: "Authorization Code",
        enterAuthorizationCode: "Enter authorization code",
        lastModification: "Last modification on {modifiedOn, date, long} by {modifiedBy}",
        newMemberApprovalUser: "New member admin",
    },
    mfaPreferenceForm: {
        mfaPreference: "MFA preference",
        mfaInfo:
            "Please select your preference for receiving the multi-factor authentication code. This code will be requested each time you connect to the application.",
        successfullUpdate: "Your changes have been taken into account",
    },
    datatable: {
        actions: "Actions",
        noData: "No data to display",
        select: "Select all",
        refreshData: "Refresh data",
        position: {
            results: "Results",
            total: "total",
        },
        search: {
            placeholder: "Search...",
        },
    },
    divisions: {
        title: "Divisions",
        datatable: {
            actions: {
                add: "Add division",
                edit: "Edit division",
                view: "View division",
                includeArchivedDivisions: "Include archived divisions",
            },
            columns: {
                division: "Division",
                status: "Status",
                sync: "Sync.",
                externalDivisionNumber: "Telus or Desjardins division number",
            },
            toolTips: {
                syncToolTipArchived: "Archived divisions are not synchronizable.",
                syncToolTipWarning: "The division is not synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTip: "The division is synchronized.",
                syncToolTipStarted: "The synchronization of the division is in progress.",
            },
            syncDisplayStatus: {
                success: "All divisions are synchronized",
                warning: "Some divisions are not synchronized",
                danger: "No divisions are synchronized",
            }
        },
        form: {
            name: "Division name",
            divisionNumber: "Division number",
            externalDivisionNumber: "Telus or Desjardins division number",
            province: "Province",
            syncDisplayStatus: {
                success: "The division is synchronized.",
                started: "The synchronization of the division is in progress.",
                dangerErrors: "One or more synchronization errors have occurred:",
                danger: "The division is not synchronized.",
            }
        },
        errors: {
            divisionActiveCoverageError: "The division has one or more active member coverage(s), which blocks archiving.",
            divisionActiveCoverageAndClassError: "The division has one or more member coverage(s) and active class(es), which blocks archiving.",
            divisionActiveClassError: "The division has one or more active class(es) which blocks archiving."
        }
    },
    error: {
        403: {
            title: "403 Unauthorized",
            link: "Go back to homepage",
        },
        404: {
            title: "404 Page Not Found",
            link: "Go back to homepage",
        },
        noData: {
            title: "No associated client",
            description: "Your account is not associated to any client. Please contact your account manager if you believe this is an error.",
            link: "Reload"
        },
        unknown: "An unknown error has occurred",
    },
    clientClasses: {
        title: "Classes",
        errors: {
            classActiveCoverageError: "You cannot archive a class associated with member coverage",
            newClassInactivationError:
                "You cannot create a class whose start date is after the client's inactivation date.",
            modifyClassInactivationError:
                "You cannot modify a class whose start date is after the client's inactivation date.",
        },
        datatable: {
            actions: {
                add: "Add class",
                edit: "Edit class",
                view: "View class",
                includeArchivedClasses: "Include archived classes",
                editConfirmationTitle: "Warning!",
                editConfirmationMessage:
                    "<p>Where applicable: Removing a guarantee for an existing class will affect all members adhering to it. Their coverage will be modified the first day of next month, and the next invoice will reflect these changes.</p>" +
                    "<p>Where applicable: For any new guarantee added to an existing class, it will be necessary to manually adjust the coverage of members who wish to adhere to it.</p>" +
                    "<p>Are you certain you wish to make changes to this existing class?</p>",
                warnings: {
                    noCoverages:
                        "There are no coverage prices defined for the selected client. You must define coverage prices before you can create client classes.",
                },
            },
            columns: {
                class: "Class",
                division: "Parent division",
                status: "Status",
                externalClassNumber: "Telus or Desjardins class number",
                sync: "Sync",
            },
            toolTips: {
                syncToolTipWarning: "The class is not synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTip: "The class is synchronized.",
                syncToolTipArchived: "Archived classes are not synchronizable.",
                syncToolTipStarted: "The synchronization of the class is in progress."
            },
            syncDisplayStatus: {
                success: "All classes are synchronized",
                warning: "Some classes are not synchronized",
                danger: "No classes are synchronized",
            }
        },
        form: {
            name: "Class name",
            classNumber: "Class number",
            externalClassNumber: "Telus or Desjardins class number",
            divisionId: "Division parent number",
            fiscalSplit: {
                startDate: "Applicable from",
                actives: "Active guarantees",
                guarantees: "Guarantees",
                inactives: "Inactive guarantees",
                inOptimization: "Part of fiscal optimization",
                outOfOptimization: "Out of fiscal optimization",
                employerPortion: "Employer Portion",
                exclude: "Exclude",
                type: "Employer portion type",
                types: {
                    fixed: "Fixed",
                    percentage: "Percentage",
                },
            },
            warnings: {
                doubledGuarantee: "A guarantee can't be applied more than once.",
                startDate:
                    "Modifications to this class will be applied from the start date of the billing period selected above. You cannot do modification more than 6 billing periods ago.",
                startDateGeneric:
                    "Modifications to this class will be applied from the start date of the billing period selected above.",
                startDateForRecurring:
                    "Modifications to this class will be applied from the start date of the billing period selected above. Classes can only be created or modified from {date} .",
                mandatoryDivision:
                    "The client must have at least one unarchived division to create a class.",
            },
            syncDisplayStatus: {
                success: "The class is synchronized.",
                started: "The synchronization of the class is in progress.",
                dangerErrors: "One or more synchronization errors have occurred:",
                danger: "The class is not synchronized.",
            }
        },
    },
    synchronizations: {
        datatable: {
            title: "Synchronizations",
            columns: {
                status: "Status",
                date: "Date",
                client: "Client",
                user: "User",
                member: "Member",
                details: "Details",
                dependents: "Dependents",
                clients: "Clients",
                event: "Event",
                elementType: "Element Type",
                element: "Element",
                info: "Info",
            },
            filters: {
                allUsers: "All users",
                allClients: "All clients",
                allElementTypes: "All element types"
            },
            elementType: {
                client: "Client",
                division: "Division",
                class: "Class",
                member: "Member",
                dependentPerson: "Dependent Person",
            },
            eventName: {
                divisionCreated: "Division created",
                divisionUpdated: "Division updated",
                divisionArchived: "Division archived",
                telusServiceDivisionUpdated: "Division updated",
                telusDivisionSynchronized: "Telus Division synchronized",
                telusDivisionSynchronizationFailed: "Telus Division synchronization failed",
                classCreated: "Class created",
                telusClassSynchronized: "Telus Class synchronized",
                telusClassSynchronizationFailed: "Telus Class synchronization failed",
                clientCreated: "Client created",
                clientUpdated: "Client updated",
                clientInactivityPlanned: "Client inactivity planned",
                clientInactivityCanceled: "Client inactivity canceled",
                clientArchived: "Client archived",
                coveragePeriodUpdated: "Coverage period updated",
                telusClientSynchronized: "Telus Client synchronized",
                telusClientSynchronizationFailed: "Telus Client synchronization failed",
                dependentPersonCoverageCreated: "Dependent person coverage created",
                dependentPersonCoverageUpdated: "Dependent person coverage updated",
                dependentPersonUpdated: "Dependent person updated",
                dependentPersonArchived: "Dependent person archived",
                dependentPersonCoverageSyncActivated: "Dependent person coverage sync activated",
                dependentPersonSyncActivated: "Dependent person sync activated",
                telusDependentPersonCoverageSynchronized: "Telus Dependent person coverage synchronized",
                telusDependentPersonCoverageSynchronizationFailed: "Telus Dependent person coverage synchronization failed",
                memberUpdated: "Member updated",
                memberArchived: "Member archived",
                memberSyncActivated: "Member sync activated",
                memberCoverageUpdated: "Member coverage updated",
                memberCoverageArchived: "Member coverage archived",
                memberCoverageSyncActivated: "Member coverage sync activated",
                memberCoverageCreated: "Member coverage created",
                telusMemberCoverageSynchronized: "Telus Member coverage synchronized",
                telusMemberCoverageSynchronizationFailed: "Telus Member coverage synchronization failed"
            },
            buttons: {
                applyFilter: "Apply the filters",
                includeLinkedElements: "Include linked elements"
            },
            resyncButtonMsg: "Relaunch synchronization",
            resyncMessages: {
                resyncSent: "A retry has been launched. A new synchronization will take place if the item is eligible.",
                resyncError: "The selected synchronization is not eligible for retry.",
                resyncUnknownError: "An error has occurred and it is not possible to restart this synchronization.",
            },
        },
    },
    clientCoverages: {
        title: "Client Rates",
        errors: {
            newClientCoverageInactivationError:
                "You cannot create a coverage whose start date is after the client's inactivation date.",
            modifyClientCoverageInactivationError:
                "You cannot modify a coverage whose start date is after the client's inactivation date.",
        },
        datatable: {
            actions: {
                add: "Add client rate",
                edit: "Edit client rate",
                view: "View client rate",
                includeArchivedClientCoverages: "Include archived client coverages",
                confirmationMessages: {
                    title: "Warning!",
                    editWarning:
                        "<p>Changing coverage prices will affect all members adhering to its associated guarantee. Their coverage will be modified the first day of next month, and the next invoice will reflect these changes.</p>" +
                        "<p>Are you certain you wish to make changes?</p>",
                    genericReview:
                        "<p>Please review the following: </p>" +
                        "<p><strong>Applicable on </strong> <span>{startDate}</span></p>" +
                        "<p><strong>Garantee </strong> <span>{guaranteeName}</span></p>" +
                        "<p><strong>Insurer </strong> <span>{insurerName}</span></p>" +
                        "<p><strong>Commission rate </strong> <span>{commissionRate}%</span></p>" +
                        "<br />",
                    FIXED:
                        "<p><strong>Invoiced client rate</strong> <span>$ {invoicedClientRate}</span></p>" +
                        "<p><strong>Client rate</strong> <span>$ {clientRate}</span></p>" +
                        "<p><strong>Provider rate</strong> <span>$ {providerRate}</span></p>",
                    FORMULA_FIXED:
                        "<p><strong>Formula</strong> <span>Volume / {formulaDenominator} * Rate</span></p>" +
                        "<p><strong>Volume calculation</strong> <span>Montant fixe</span></p>" +
                        "<p><strong>Volume</strong> <span>$ {formulaVolume}</span></p>" +
                        "<p><strong>Invoiced client rate</strong> <span>$ {invoicedClientRate}</span></p>" +
                        "<p><strong>Client rate</strong> <span>$ {clientRate}</span></p>" +
                        "<p><strong>Provider rate</strong> <span>$ {providerRate}</span></p>",
                    FORMULA_SALARY:
                        "<p><strong>Formula</strong> <span>Volume / {formulaDenominator} * Rate</span></p>" +
                        "<p><strong>Volume calculation</strong> <span>Calculate as per annual salary</span></p>" +
                        "<p><strong>Annual salary</strong> <span>/ {formulaSalaryDenominator, select, 1 {1 Year} 12 {12 Months} 52 {52 Weeks}}</span></p>" +
                        "<br />" +
                        "<p><strong>Portion 1</strong> <span>{formulaPart1, select, null {All} other {{formulaPart1}}} * {formulaMultiple1, select, null {0} other {{formulaMultiple1}}}</span></p>" +
                        "{formulaPart1, select, null {} other {" +
                        "<p><strong>Portion 2</strong> <span>{formulaPart2, select, null {Surplus} other {{formulaPart2}}} * {formulaMultiple2, select, null {0} other {{formulaMultiple2}}}</span></p>" +
                        "{formulaPart2, select, null {} other {" +
                        "<p><strong>Portion 3</strong> <span>{formulaPart3, select, null {Surplus} other {{formulaPart3}}} * {formulaMultiple3, select, null {0} other {{formulaMultiple3}}}</span></p>" +
                        "}}" +
                        "}}" +
                        "<br />" +
                        "<p><strong>Ceil to</strong> <span>$ {formulaRoundedNumber}</span></p>" +
                        "<p><strong>MSPA</strong> <span>$ {formulaMspa}</span></p>" +
                        "<p><strong>Maximum</strong> <span>$ {formulaMaximum}</span></p>" +
                        "<p><strong>Invoiced client rate</strong> <span>$ {invoicedClientRate}</span></p>" +
                        "<p><strong>Client rate</strong> <span>$ {clientRate}</span></p>" +
                        "<p><strong>Provider rate</strong> <span>$ {providerRate}</span></p>",
                    MEMBER: "<p>The selected guarantee is a 'Member' type.</p>",
                    MEMBER_MULTIPLIER: "<p>The selected guarantee is a 'Member (invoiced rate)' type</p>",
                    PRICE_LIST_DEFAULTS:
                        "<p class='headers'><strong>Class</strong><strong>Coverage</strong><strong>Invoiced client rate</strong><strong>Client rate</strong><strong>Provider rate</strong><strong>TPA Fee</strong><strong>Gap</strong></p>" +
                        "<p><span>Default</span><span>Single</span><span>$ {defaultInvoicedClientRateSingle}</span><span>$ {defaultClientRateSingle}</span><span>$ {defaultProviderRateSingle}</span><span>$ {defaultTpaFeeSingle}</span><span>$ {defaultGapFeeSingle}</span></p>" +
                        "<p><span>Default</span><span>Couple</span><span>$ {defaultInvoicedClientRateCouple}</span><span>$ {defaultClientRateCouple}</span><span>$ {defaultProviderRateCouple}</span><span>$ {defaultTpaFeeCouple}</span><span>$ {defaultGapFeeCouple}</span></p>" +
                        "<p><span>Default</span><span>Family</span><span>$ {defaultInvoicedClientRateFamily}</span><span>$ {defaultClientRateFamily}</span><span>$ {defaultProviderRateFamily}</span><span>$ {defaultTpaFeeFamily}</span><span>$ {defaultGapFeeFamily}</span></p>" +
                        "<p><span>Default</span><span>Single parent</span><span>$ {defaultInvoicedClientRateSingleParent}</span><span>$ {defaultClientRateSingleParent}</span><span>$ {defaultProviderRateSingleParent}</span><span>$ {defaultTpaFeeSingleParent}</span><span>$ {defaultGapFeeSingleParent}</span></p>" +
                        "<p><span>Default</span><span>Waived</span><span>$ {defaultInvoicedClientRateWaived}</span><span>$ {defaultClientRateWaived}</span><span>$ {defaultProviderRateWaived}</span><span>$ {defaultTpaFeeWaived}</span><span>$ {defaultGapFeeWaived}</span></p>",
                    PRICE_LIST_LINES:
                        "<p class='{coverageType, select, SINGLE {border-top} other {}}'>" +
                        "<span>{className}</span>" +
                        "<span>{coverageType, select, SINGLE {Single} COUPLE {Couple} FAMILY {Family} SINGLE_PARENT {Single parent} WAIVED {Waived}}</span>" +
                        "<span>$ {invoicedClientRate} $</span>" +
                        "<span>$ {clientRate} $</span>" +
                        "<span>$ {providerRate}</span>" +
                        "<span>$ {tpaFee}</span>" +
                        "<span>$ {gapFee}</span>" +
                        "</p>",
                },
            },
            columns: {
                name: "Guarantee",
                startDate: "Applicable from",
                shortName: "Abbreviation",
                code: "Assumption-Life Code",
                type: "Type",
                ageOfPolicyExpiration: "Age of expiration",
                ageOfPolicyDecrease: "Age of decrease",
                applicableTaxes: "Applicable taxes",
                commissionRate: "Commission rate",
                insurerName: "Provider",
            },
        },
        form: {
            surplusAllocation: "Surplus allocation",
            commissionRate: "Commission rate",
            markUpRate: "Mark-up",
            clientReserveRate: "Customer reserve",
            startDate: "Applicable from",
            description: "Descriptor",
            guaranteeName: "Guarantee",
            insurerName: "Provider",
            administrator: "Plan Administrator",
            policyNumber: "Policy number",
            ageOfPolicyExpiration: "Age of expiration",
            ageOfPolicyDecrease: "Age of decrease",
            percentageOfPolicyDecrease: "Pourcentage of decrease",
            applicableTaxes: "Applicable taxes (Client rate)",
            applicableTpaTaxes: "Applicable taxes (TPA rate)",
            suitableForInternationalMembers: "Suitable for international members",
            fixedRate: "Fixed rate",
            fixedType: "Fixed type",
            priceListRate: "Price list rates",
            formulaRate: "Formula rate",
            memberRate: "Member rate",
            formula: "Formula",
            formulaVolume: "Volume",
            volumeCalculation: "Volume calculation",
            rate: "Rate",
            fixed: "Fixed amount",
            perAnnualSalary: "Calculate as per annual salary",
            invoicedClientRate: {
                MONTH: "Monthly invoiced client rate",
                BILLING_PERIOD: "Invoiced client rate",
            },
            clientRate: {
                MONTH: "Monthly client rate",
                BILLING_PERIOD: "Client rate",
            },
            providerRate: {
                MONTH: "Monthly provider rate",
                BILLING_PERIOD: "Provider rate",
            },
            formulaSalaryDenominator: "Annual salary / ",
            formulaPart: "Portion",
            formulaPart1: "Empty = All",
            formulaPart2: "Empty = Surplus",
            formulaPart3: "Empty = Surplus",
            formulaMultiple: "Multiple",
            formulaRoundedNumber: "Ceil to",
            formulaMspa: "MSPA",
            formulaMaximum: "Maximum",
            class: "Class",
            coverage: "Coverage",
            default: "Default",
            couple: "Couple",
            family: "Family",
            single: "Single",
            singleParent: "Single parent",
            waived: "Waived",
            memberCoverageMessage: "You will configure it on the members coverage form.",
            tpaFee: {
                MONTH: "Monthly TPA fee",
                BILLING_PERIOD: "TPA fee",
            },
            gapFee: "Gap",
            warnings: {
                startDate:
                    "Modifications to this coverage price will be applied from the start date of the billing period selected above. You cannot apply modifications more than 6 billing periods ago.",
                startDateGeneric:
                    "Modifications to this coverage price will be applied from the start date of the billing period selected above.",
                startDateForRecurring:
                    "Modifications to this coverage price will be applied from the start date of the billing period selected above. Coverages can only be created or modified from {date} .",
                billingPeriodRate: "The rates for this client are per billing period.",
            },
        },
        taxTypes: {
            insurance: "Insurance tax",
            none: "None",
            sales: "Sales tax",
        },
    },
    clientGuarantees: {
        title: "Guarantee Configuration",
        datatable: {
            actions: {
                edit: "Edit guarantee configuration",
            },
            columns: {
                guarantee: "Guarantee",
                dependsOn: "Depends on",
                isAutomaticallyChecked: "Automatically checked",
            },
        },
        form: {
            guarantee: "Guarantee",
            dependsOnGuaranteeId: "Depends on",
            dependsOnGuaranteeIdTooltip: "Defines whether this guarantee depends on another. If so, its display and default behaviour, particularly in member coverages, will be affected. This field is disabled if the guarantee is defined as a driving mandatory dependent guarantee or as a mandatory dependent guarantee.",
            isAutomaticallyChecked: "Automatically checked",
            isAutomaticallyCheckedTooltip: "Defines whether this guarantee should be automatically activated based on the member coverage current configuration. For \"Price list\" guarantees that are dependent on another, if this option is checked and the parent guarantee type is defined, they will be activated and will inherit the same type. \"By member\" or \"By member (invoiced rate)\" guarantees cannot be automatically activated.",
        },
    },
    dependents: {
        title: "Dependents",
        datatable: {
            actions: {
                add: "Add dependent",
                edit: "Edit dependent",
                includeArchivedDependents: "Include archived dependents",
                view: "View dependent",
            },
            columns: {
                name: "Name",
                relation: "Relationship",
                gender: "Gender",
                birthdate: "Birthdate",
                smoker: "Smoker",
                sync: "Sync",
                disability: "Disability",
            },
            disability: {
                yes: "Yes",
                no: "No",
            },
            toolTips: {
                dependentNoSync: "The dependent is not synchronisable.<br/><br/>1- The dependent must not be archived.<br/><br/>2- The dependent must have at least one coverage.",
                syncToolTipWarning: "The dependent is not synchronized.",
                syncToolTip: "The dependent is synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTipStarted: "The synchronization of the coverage is in progress."
            },
        },
        form: {
            firstName: "First name",
            lastName: "Last name",
            relation: "Relationship",
            gender: "Gender",
            birthdate: "Birthdate",
            smoker: "Smoker",
            isStudent: "Student",
            isDisabled: "Disability",
            disabilityStartDate: "Disability Start Date",
            disabilityStartDateHint: "The date cannot be before the birthdate and must be the start day of a dependent’s coverage or out of coverage.",
        },
        nav: {
            all: "All dependents",
            coverages: "Coverages",
        },
        relations: {
            spouse: "Spouse",
            child: "Child",
        },
        errors: {
            invalidDisabilityStartDateError: "The disability start date cannnot be during dependent coverage. Please pick a valid date or reach out to support if you need help.",
        }
    },
    dependentCoverages: {
        datatable: {
            actions: {
                add: "Add a coverage period",
                edit: "Modify the coverage period",
                view: "View the coverage period",
            },
            columns: {
                date: "Date",
                period: "Coverage period",
                periodFrom: "From ",
                today: "today",
                name: "Name",
                relation: "Relationship",
                gender: "Gender",
                birthdate: "Birthdate",
                smoker: "Smoker",
                student: "Student",
                status: "Status",
                sync: "Sync",
            },
            student: {
                yes: "Yes",
                no: "No",
            },
            toolTips: {
                syncToolTipWarning: "The dependent coverage is not synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTip: "The dependent coverage is synchronized.",
                syncToolTipStarted: "The synchronization of the coverage is in progress.",
                relatedCoverageToolTipWarning: "Coverage from a previous session was synchronized more recently than this one. The coverage dates in Telus Adjudicare may not be up to date."
            },
        },
        form: {
            billingPeriod: "Billing period",
            startDate: "Start date",
            endDate: "End date",
            status: "Status",
            inactivityReason: "Inactivity reason",
            inactivityReasonDate: "Withdrawal date",
            inactivityReasonDetails: "Specify",
            noBillingPeriod: "No billing period available for the dependent coverage. Please check if the client has periods and that the latest period is not already assigned to another dependent coverage.",
        },
        errors: {
            invalidCreateDisabilityStartDateError: "The dependent's disability start date falls within a coverage. Please choose a valid date, then update the coverage or contact support for help",
            invalidUpdateDisabilityStartDateError: "The dependent's disability start date falls within a coverage. Please choose a valid date, then create the coverage or contact support for help",
            conflictedDatesError: "The chosen coverage dates overlap with existing dependent coverages. Please review and adjust the dates."
        }
    },
    download: {
        title: "Download file",
        form: {
            languageCode: "File language",
        },
        errors: {
            noCoverageFound: "The selected member does have any coverages",
            Unauthorized: "You are not auhorized to download this file"
        },
    },
    followUps: {
        title: "Follow-Ups",
        pages: {
            list: "Follow-ups {followUpsCount, plural, =0 {} other {({followUpsCount})}}",
            messages: "Messages {messagesCount, plural, =0 {} other {({messagesCount})}}",
        },
        list: {
            datatable: {
                actions: {
                    add: "Add Follow-up",
                    edit: "Edit Follow-up",
                    view: "View Follow-up",
                    includeClosedFollowUps: "Display open and closed follow-ups",
                    showOnly: "Display only",
                    followUpTypes: {
                        title: "Follow-up",
                        note: "Note with follow-up",
                        incidentFollowUp: "Incident follow-up",
                        specialModification: "Special modification",
                    },
                },
                columns: {
                    priority: "Priority",
                    creation: "Creation",
                    deadline: "Deadline",
                    description: "Description",
                    creator: "Creator",
                    client: "Client",
                    member: "Member",
                    assigned: "Assigned",
                    category: "Category",
                    status: "Status",
                },
                recipient: "{status, select, OPEN{for} CLOSED{by}} {recipientName}",
            },
        },
        filters: {
            all: "All follow-ups",
            toMe: "Follow-ups assigned to me",
            fromMe: "Follow-ups I created or forwarded",
            member: "Member filter",
        },
    },
    gender: {
        female: "Female",
        male: "Male",
        nd: "N/D",
    },
    importExport: {
        title: "Import / Export",
        actions: {
            import: "Import",
            export: "Export",
            publish: "Publish",
        },
        exportManyInvoices: {
            subTitle: "Export and publish invoices of corporate clients",
            form: {
                blocs: "Blocs",
                clients: "Clients",
                period: "Period",
                selectType: "Selection type",
            },
            messages: {
                error: "An error has occurred:",
                errors: {
                    BAD_REQUEST: "Error while handling the request.",
                    NOTHING_TO_PUBLISH: "There are no invoices to publish with the current criteria.",
                    UNKNOWN_ERROR: "Unknown error.",
                },
                success: "The request has been processed successfully:",
                successes: {
                    export: "An email containing the invoices will be sent in the next 12 hours.",
                    publish: "Invoices have been published.",
                },
                successWait: "An email containing the invoices will be sent in the next 12 hours.",
                validation: {
                    clientSelection: "You much select at least one client when selecting inclusions",
                },
            },
            export: {
                modal: {
                    description:
                        "Only the non-generated invoices will be generated. But all invoices listed bellow will be sent in the email link once the process is complete.",
                    title: "Export preview",
                },
            },
            publish: {
                modal: {
                    description:
                        "Only the generated and currently generating invoices will be published. Once published, the invoices will be available from the plan administrator account of the client.",
                    title: "Publish preview",
                    titles: {
                        client: "Client",
                        invoice: "Invoice",
                        status: "Status",
                    },
                    statuses: {
                        invoice:
                            "The invoice <strong>{invoice}</strong> for the period <strong>{period}</strong> of <strong>{client}</strong> ",
                        generated: "is ready to be published.",
                        generating: "is currently being generated and will be published as soon as it is ready.",
                        notGenerated: "has not been generated yet.",
                        published: "has already been published.",
                        short: {
                            generated: "Generated",
                            generating: "Generating",
                            notGenerated: "Not generated",
                            published: "Published",
                        },
                    },
                },
            },
            selectionTypes: {
                exclude: "Exclude selected clients",
                include: "Export only the selected clients",
            },
        },
        exportAcomba: {
            form: {
                blocs: "Blocs",
                clients: "Clients (optional)",
                intervalEnd: "Interval end",
                intervalStart: "Interval start",
                exportType: "Mode",
            },
            messages: {
                error: "An error occurred during the invoice exportation:",
                errors: {
                    NO_ACOMBA_CUSTOMER_NUMBER: "No Acomba customer number.",
                    NO_ACOMBA_FEE_NUMBER: "No Acomba fee number.",
                    NO_ACOMBA_GST_NUMBER: "No Acomba GST number.",
                    NO_ACOMBA_HST_NUMBER: "No Acomba HST number.",
                    NO_ACOMBA_INSURER_NUMBER: "No Acomba insurer number.",
                    NO_ACOMBA_PAYABLE_NUMBER: "No Acomba payable number.",
                    NO_ACOMBA_PREMIUM_NUMBER: "No Acomba premium number.",
                    NO_ACOMBA_QST_NUMBER: "No Acomba QST number.",
                    NO_ACOMBA_RECEIVABLE_NUMBER: "No Acomba receivable number.",
                    NO_BLOC_ERROR: "No report to export for the selected bloc.",
                    NO_CLIENT: "No clients selected.",
                    NO_INVOICE_ERROR: "No invoice to export in the selected period.",
                    NO_PROJECT_NUMBER: "No Acomba project number.",
                    INVOICE_DATA_ERROR: "Errors in the invoice data.",
                    INVOICE_DATA_TOTAL_ZERO: "The total of the invoice is 0.",
                    UNKNOWN_ERROR: "Unknown error.",
                    NO_PROVINCE_ACOMBA_NUMBER: "No province Acomba number.",
                    NO_PROVINCE_FEDERAL_TAX_TYPE: "No province federal tax type.",
                    FTP_ERROR: "An error occurred while trying to connect to the FTP server.",
                },
                success: {
                    generic: "The invoice exportation was completed successfully.",
                    errors: " with errors",
                    transferred: " exported.",
                    linkText: "{number} {number, plural, one {invoice} other {invoices}}",
                    modal: {
                        errors: {
                            title: "Invoices with export errors",
                        },
                        transferred: {
                            title: "Invoices exported",
                        },
                    },
                },
                warning: {
                    generic: "The invoice exportation was completed, but some errors were encountered.",
                },
            },
        },
        exportInsurers: {
            form: {
                insurer: "Insurer",
                periodDate: "Period",
                languageCode: "Language",
                fileFormat: "Format",
            },
        },
        exportMembers: {
            form: {
                client: "Client",
                billingPeriod: "Billing Period",
                fileFormat: "Format",
                mustHaveMemberIdentifierRecoveryDate: "Only members that recovered their Major Code",
            },
        },
        exportReceivables: {
            form: {
                blocs: "Blocs",

                billingPeriod: "Billing Period",
                message: "No data available for the selected parameters",
            },
        },
        exportPayables: {
            form: {
                blocs: "Blocs",
                billingPeriod: "Billing Period",
                message: "No data available for the selected parameters",
            },
        },
        importMembers: {
            confirmation: {
                title: "Confirmation",
                message: "Please review and confirm the following:",
                fileName: "File Name",
                class: "Class",
                classWarning:
                    "Please note that existing coverages may be modified during import (particularly the MEMBER-CLASS association). Please confirm if you wish to proceed based on the entered parameters.",
            },
            form: {
                client: "Client",
                billingPeriod: "Billing Period",
                class: "Class",
                format: "Format",
                file: "File",
                fileDesc: "Drop the file you wish to upload here",
                importSessionPeriod: "Session to import",
                warnings: {
                    noClientNumber:
                        "Importing members is currently impossible, as no client number has been provided in the client profile, under 'General informations' section.",
                    noClasses:
                        "There are no classes defined for the selected client. You must define at least one class before you can import a member list.",
                    noCoverages:
                        "There are no coverage prices defined for the selected client. You must define coverage prices before you can import a member list.",
                    noDivisions:
                        "There are no divisions defined for the selected client. You must define at least one division before you can import a member list.",
                    automaticMemberIdentifier: "Automatic unique numbers would be created for this client",
                    clientInTransition:
                        "Please note that technical actions related to the client inactivity scheduling are in progress. Your modifications may be disrupted by this technical process. We recommend that you wait a few minutes.",
                },
            },
            messages: {
                success: "The importation was completed successfully.",
                warning:
                    "The importation is completed but a non blocking error has been detected.",
                error: "An error occurred during the importation:",
                received: "{received, number} {numberOfReceived, plural, one {member} other {members}} received",
                updated: "{updated, number} {numberOfUpdated, plural, one {member} other {members}} updated",
                imported: "{imported, number} {numberOfImported, plural, one {member} other {members}} imported",
                transferred:
                    "{transferred, number} {numberOfTransferred, plural, one {member} other {members}} transferred to the new billing period",
                renewed:
                    "{renewed, number} {numberOfRenewed, plural, one {member} other {members}} renewed to the new billing period",
                successDetails: "Imported {received, number} members.",
                existingMembers: "Please note that the following {numberExistingMembers, plural, one {participant was} other {participants were}} duplicated in the list to be imported or already covered : {existingMembers}",
                droppedOutWarning: "The following members could not be imported because they are currently marked as 'dropped out'. Please update them manually:{br}{nonImportedMembersList}",
            },
            errors: {
                message: "For the member N° {member_identifier}, error in data '{key}': ",
                expected: "Expected {numberOfValues, plural, one {value} other {values}}",
                value: "Actual value",
                lastActiveDateError: "Start date or end date for coverage for one or more member(s) is either empty or later than client's last active date : {lastActiveDate} . Please verify the values and try again",
                code: {
                    ValueError: "Data error",
                    NotFoundError: "Not found",
                    ValueRegexError: "Improper",
                    DuplicateError: "Duplicate",
                    MaxLengthError: "Maximum length exceeded (max. {expected})",
                },
                key: {
                    birthdate: "Birth date",
                    coverageCode: "Coverage code",
                    firstName: "First name",
                    lastName: "Last name",
                    memberIdentifier: "Member identifier",
                    memberGenderType: "Gender",
                    schoolIdentifier: "School identifier",
                    isInternational: "International",
                    quarter: "Quarter",
                    invoicedAmount: "Invoiced amount",
                    address: "Postal address",
                    city: "City",
                    postalCode: "Postal code",
                    phoneNumber: "Phone number",
                    emailAddress: "Email",
                    personalIdentifier: "Personnal identifier",
                    lastActiveDateError: "Start date for coverage is after client's last active date",
                },
            },
        },
        agecro: {
            sessionTypes: {
                winter: "Winter",
                summer: "Summer",
                fall: "Fall"
            },
            memberInformationsTable: {
                birthdate: "Birth date",
                coverageCode: "Coverage code",
                firstName: "First name",
                lastName: "Last name",
                memberIdentifier: "Member identifier",
                invoicedAmount: "Invoiced amount",
                statusFees: "Fee status",
                session: "Session"
            },
            errors: {
                fetchingStudents: "Unable to retrieve the list of students from the Rosemont API. The connection to the API may not be operational, or the selected billing period may not return any information."
            }
        },
        formats: {
            agecar: "University model, Major withdrawal (AGECAR)",
            agectr: "CEGEP model, Major withdrawal (AGECTR)",
            ageuqtr: "University model, in-house withdrawal (AGEUQTR)",
            aelcc: "AELCC Format",
            aeteluq: "AETELUQ (import via API)",
            agecro: {
                continuingEducation: "AGECRo - Continuing Education (import via API)",
                regularEducation: "AGECRo - Regular Education (import via API)",
                onlineEducation: "AGECRo - Online Education (import via API)"
            },
            mondial: "Travel list Model",
            withdrawal: "List of withdrawn members",
            symbility: "Symbility Model",
            corporate: "Corporate Model",
            eligibility_report_1: "Eligibility report 1",
            akira: "Telemedecine Model",
            eligibility_report_2: "Eligibility report 2",
            ftp: "Upload to FTP",
            manual: "Manual",
            premiums: "Premiums Model",
            feus: "FEUS Model",
        },
        exports: {
            form: {
                exportationType: "Exportation type",
            },
        },
        exporting: "Exportation in progress",
        importing: "Importation in progress",
        pages: {
            importMembers: "Import",
            exports: "Export",
            accountingExports: "Accounting",
            exportAcomba: "Acomba export",
            exportManyInvoices: "Export/Publish invoices",
            exportInsurers: "Export Insurers",
            reports: "Available Reports",
        },
        exportTypes: {
            client: "Client",
            insurers: "Insurers",
            acomba: "Acomba",
            corporate: "Publication of invoices from corporate clients",
            receivables: "Receivables",
            payables: "Payables",
        },
    },
    invoices: {
        title: "Invoices",
        datatable: {
            informations: {
                beginingNextPeriod: "Start of the next review period: ",
                finalInvoiceGeneration: " Generation of final invoices STANDARD: ",
                finalInvoiceGenerationDelayed: " Generation of final invoices OFFSET: ",
                standardInvoiceType: "STANDARD",
                creditsInvoiceType: "ADJUSTMENTS",
                templateInvoiceType: "TEMPLATE",
                terminationInvoiceType: "TERMINATION",
            },
            actions: {
                unauthorizedDelayAction: "Your role does not have the rights to delay billing periods.",
                warning: " WARNING ",
                warningMessage:
                    "Changes have been made to the client's settings. Please review the invoice to see the impact of these changes.",
                normalMessage:
                    "No data changes have been made. The version currently available reflects the most current version of the client data.",
                add: "Generate invoice",
                cancel: "Cancel invoice",
                view: "View invoice",
                editBillingAddress: "Billing options",
                invoiceOffset: "Offset of the invoice : {bpName}",
                templateInvoice: "Generate invoice template",
                templateError: "An error has occured while generating the template invoice",
                templateMissingClientInfo:
                    "The invoice in TEMPLATE format is generated for an amount of 0$, please check your client's guarantees settings.",
                templateMissingBillingPeriod:
                    "The IMPLEMENTATION client does not have a billing period for next month.",
                templateGenerationSuccess: "The template invoice was generated successfully",
                templateGenerationFailure: "The template invoice could not be generated. Please try again",
                reviewGenerationSuccess: "The invoice was reviewed successfully",
                reviewGenerationFailure: "The invoice could not be reviewed. Please try again",
                modalInvoiceDelayedWarning:
                    "Warning, if you delay the billing period {bpName}, the customer's invoice will be generated during the delayed invoicing step. This action is irreversible, no reversal will be possible. </strong> Are you sure you want to shift the generation of this invoice?",
                noBillingPeriods:
                    "There are no billing periods configured for client. You must define at least one billing period before you can generate an invoice.",
            },
            columns: {
                amount: "Amount",
                billingPeriod: "Billing period",
                endDate: "End Date",
                invoiceNumber: "Invoice number",
                startDate: "Start Date",
                status: "Invoice state",
                summaryOnly: "Summary only",
                summaryAndListOfParticipants: "Summary and list of{br}participants",
                summaryCostsAndCoverages: "Summary of costs and{br}coverages",
                invoiceType: "Invoice type",
            },
        },
        form: {
            billingPeriodModal: {
                title: "Billing Period",
            },
            addressSettings: {
                title: "Billing address",
            },
            otherSettings: {
                title: "Other options",
            },
            recipient: "Recipient",
            address: "Address",
            city: "City",
            country: "Country",
            province: "Province",
            postalCode: "Postal code",
            phoneNumber1: "Phone number 1",
            phoneNumber2: "Phone number 2",
            fax: "Fax",
            emailAddress: "Email address",
            website: "Website",
            showPaymentNotice: "Show payment notice",
            ungroupGuaranteesInInvoices: "Ungroup guarantees in invoices",
            includeWithdrawalMembers:
                "Include members with a <span class='emphasis'>Inactive - Withdrawn</span> status in invoices",
        },
        cancelButton: {
            title: "Cancel invoice",
            standardMessage: "Are you sure you can to cancel invoice {invoiceName}",
            warningMessage:
                "<p>Cancelling an invoice in the past will impact the calculations of future invoices.</p>" +
                "<p>Are you certain you wish to cancel invoice {invoiceName}?</p>",
        },
        resetButton: {
            title: "Reset invoice",
            message: "Are you sure you can to reset invoice {invoiceNumber}'s status?",
        },
        status: {
            exportedToAcomba: "Exported",
            failure: "Failure",
            generated: "Generated",
            generating: "In process of generation",
            notGenerated: "Not generated",
            review: "Review",
            template: "Template",
            published: "Published",
        },
        view: {
            title: "View invoice",
            form: {
                fileType: "Format",
                insurerId: "Insurer",
            },
            types: {
                PDF: "PDF",
                EXCEL: "EXCEL",
                longPDF: "Summary and members list (PDF)",
                shortPDF: "Summary only (PDF)",
                longExcel: "Summary and members list (Excel)",
                shortExcel: "Summary only (Excel)",
                shortInsurerExcel: "Summary of the insurers only (Excel)",
                summaryExcel: "Summary of costs and coverages (Excel)",
                premiumByInsurer: "Premium report by insurer",
            },
            invoiceTypes: {
                credits: "Adjustments",
            },
        },
    },
    locale: {
        "en-CA": "English",
        "fr-CA": "French",
    },
    login: {
        title: "Major System",
        emailAddress: "Email Address",
        username: "Username",
        password: "Password",
        forgotPassword: "Forgot Password?",
        button: "Login",
        timeout: {
            title: "Session Timeout",
            body:
                "You have been inactive and your session has expired. Please close this message to open a new session.",
        },
        errors: {
            Unauthorized: "You supplied the wrong credentials.",
            login_failed_locked:
                "You are currently blocked from the application due to multiple failed connections.<br />Please use the forgotten password procedure to unlock you account.",
            login_failed:
                "You supplied the wrong credentials.<br />You will be blocked from the application if you fail {triesLeft} more {triesLeft, plural, one {time} other {times}}.",
            connection_timeout: "Session expired.Please login again",
        },
        associatedClientsLoadError: "Error loading your clients. Please refresh the page.",
        environments: {
            local: "Local Environment",
            qa: "QA Environment",
            qa2: "QA2 Environment",
            staging: "Staging Environment",
            demo: "Demo Environment",
        },
    },
    resetPassword: {
        title: "Major System",
        passwordExpired: "Your password has expired.",
        username: "Username",
        emailAddress: "Email Address",
        resetInstructions: "Enter the username and email address associated with your account to reset your password.",
        emailSent:
            "If an account exists with the provided information, we will send you an email with instructions to reset your password.",
        password: "Password",
        confirmPassword: "Confirm password",
        reinitializePassword: "Reinitialize Password",
        submit: "Submit",
        resend: "Resend email",
        change: "Change",
        goToLogin: "Back to login",
        resetProcessed: "If the information submitted is valid, a password reset email will be sent.",
        resetFailed: "Password couldn't be reset, please try again",
        invalidToken:
            "Your connection link has expired, a reminder has been sent to you by email notification.<br />If you have any problems connecting, please contact your account manager.",
        resetSucceeded: "Password reset",
        newPasswordInstructions: "Please enter a new password.",
        userFullName: "{userFullName},",
        passwordChanged: "Your password has been successfully saved.",
        loginCredentials: "You can now log in with it and your username directly through ",
        followingLink: "the following link",
        errors: {
            passwordsMatch: "Passwords don't match",
            passwordRequirements: "The new password doesn't fulfill the security requirements",
            invalidToken:
                "Your connection link has expired, a reminder has been sent to you by email notification.<br />If you have any problems connecting, please contact your account manager.",
            samePasswordError: "The new password cannot be identical to the old one",
            resetPasswordFailed: "An error occurred during the operation",
            "Server Error": "An error occurred during the operation",
            ssoPasswordResetError: "You cannot reuse a previously configured password",
        },
    },
    memberCoverages: {
        title: "Coverage",
        errors: {
            modalTitles: {
                generic: "Error",
                missing_required_fields: "Incomplete profile",
                overlapping_coverage: "Conflicting dates",
            },
            messages: {
                fields: {
                    address: "Address",
                    birthdate: "Date of birth",
                    city: "City",
                    countryCode: "Country",
                    firstName: "First anme",
                    employment: "Employment",
                    lastName: "Last name",
                    memberGenderType: "Sex",
                    postalCode: "Postal code",
                    provinceCode: "Province",
                },
                generic: "Something went wrong.",
                missing_required_fields:
                    "The coverage can not be edited or created because some information is missing. " +
                    "Please make sure the following fields are complete in member's profile:",
                end_date_required_for_inactivation_error:
                    "End date is mandatory for clients who are inactive, terminated, or have an inactivation planned.",
                overlapping_coverage: "The duration provided conflicts with other coverages.",
                modifyMemberCoverageInactivationError:
                    "You cannot modify a coverage with a start date that is after the client's inactivation date.",
                newMemberCoverageInactivationError:
                    "You cannot create a coverage with a start date that is after the client's inactivation date.",
                clientStatusTypeError: "You can't create a member_coverage for an INACTIVE client.",
                "Bad Request": "An error occurred. Please verify the provided information.",
            },
        },
        datatable: {
            actions: {
                add: "Add coverage",
                edit: "Edit coverage",
                view: "View coverage",
            },
            toolTips: {
                syncToolTipWarning: "The coverage is not synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTip: "The coverage is synchronized.",
                syncToolTipStarted: "The synchronization of the coverage is in progress.",
                relatedCoverageToolTipWarning: "Coverage from a previous session was synchronized more recently than this one. The coverage dates in Telus Adjudicare may not be up to date."
            },
            addTypes: {
                class: "Change of class",
                division: "Change of division",
                new: "New coverage",
                other: "Other change",
                salary: "Change of salary",
                status: "Change of status",
                type: "Change of type",
            },
            columns: {
                date: "Date",
                period: "Coverage period",
                periodFrom: "From ",
                today: "today",
                type: "Type",
                class: "Class",
                status: "Status",
                occupation: "Occupation",
                salary: "Salary",
                sync: "Sync.",
            },
        },
        form: {
            arePremiumsWaived: "Premiums waived",
            billingPeriod: "Billing period",
            startDate: "Start date",
            defineEndDate: "Define an end date",
            endDate: "End date",
            status: "Status",
            inactivityReason: "Inactivity reason",
            inactivityReasonDate: "Withdrawal date",
            inactivityReasonDetails: "Specify",
            coverageType: "Type",
            paid: "Paid",
            paidToBroker: "Premium paid directly to Major",
            type: "Type",
            class: "Class",
            division: "Division",
            occupation: "Occupation",
            salary: "Salary",
            guarantees: "Guarantees",
            noGuarantees: "This class has no guarantees assigned to it yet...",
            noSelection: "Please select a class to view its associated guarantees.",
            ageOfPolicyExpiration: "Age of expiration",
            ageOfPolicyDecrease: "Age of decrease",
            volume: "Volume",
            warningRetroModification: "You cannot apply a coverage modification.",
            warningDateForRecurring: "Coverage can only be created or updated from {date}.",

            allowance: {
                MONTH: "Monthly client rate",
                BILLING_PERIOD: "Client rate",
            },
            supplierRate: {
                MONTH: "Monthly provider rate",
                BILLING_PERIOD: "Provider rate",
            },
            removeFromList: "Remove from student association's lists",
            mustNotInvoice: "Do not add to invoice",
            formulaMspa: "Different volume",
        },
        modal: {
            dependent: {
                singleTitle: "Warning – Benefit automatically removed",
                singleMessage: "The {guaranteeName} benefit has been automatically unchecked because the required conditions are no longer met (no active driving mandatory dependent benefit with coverage other than individual).\n\nPlease review this member's coverage before confirming.",
                multipleTitle: "Warning – Benefits automatically removed",
                multipleMessageIntro: "The following benefits have been automatically unchecked because the required conditions are no longer met (no active driving mandatory dependent benefit with coverage other than individual):",
                multipleMessageOutro: "Please review this member's coverage before confirming.",
                confirmButton: "Confirm",
            },
        },
        nav: {
            all: "All dependents",
            coverages: "Coverages",
        },
        inactivityReasons: {
            notPaid: "Not paid",
            other: "other : {comment}",
            withdrawnPermanently: "Withdrawn permanently: {date}",
            withdrawnPermanentlyNotPaid: "Withdrawn permanently, Not paid : {date}",
            withdrawnYearly: "Withdrawn yearly : {date}",
            withdrawnYearlyNotPaid: "Withdrawn yearly, Not paid : {date}",
            droppedOut: "Dropped out : {date}",
            otherClean: "Other",
            withdrawnPermanentlyClean: "Withdrawn permanently",
            withdrawnPermanentlyNotPaidClean: "Withdrawn permanently, Not paid",
            withdrawnYearlyClean: "Withdrawn yearly",
            withdrawnSessionallyClean: "Withdrawn sessionally",
            withdrawnYearlyNotPaidClean: "Withdrawn yearly, Not paid",
            droppedOutClean: "Dropped out",
            deathClean: "Death",
            boughtByClientOutsideMajorClean: "Bought by client outside Major",
            boughtByMajorClientClean: "Bought by Major client",
            leavingForCompetitorClean: "Leaving for competitor",
            noLongerOffersGroupInsuranceClean: "No longer offers group insurance (too expensive)",
            eligibilityCriteriaTooSmallClean: "Eligibility criteria (group too small)",
            bankruptcyClean: "Bankruptcy",
        },
        types: {
            family: "Family",
            couple: "Couple",
            single: "Individual",
            singleParent: "Single parent",
            waived: "Waived",
            multiple: "Multiple",
            other: "Other"
        },
        validation: {
            endDateMustBeLowerThanNextCoverageStartDate: "The end date must be before the next coverage's start date",
            startDateMustBeLowerThanNextCoverageStartDate:
                "The start date must be before the next coverage's start date",
            startDateMustBeHigherThanPreviousCoverageStartDate:
                "The start date must be after the previous coverage's start date",
            guaranteeSelection: "You must select at least one guarantee",
            occupationRequired: "Please enter the participant's occupation or job title",
        },
    },
    employments: {
        title: "Employments",
        form: {
            title: "Add an employment",
            employmentType: "Type",
            startDate: "Start date",
            endDate: "End date",
            defineEndDate: "Define an end date",
        },
        datatable: {
            columns: {
                employmentType: "Type",
                date: "Date",
                periodFrom: "From ",
            },
            actions: {
                edit: "Edit employment",
                add: "Add employment",
                view: "View employment",
            },
            errors: {
                overlappingMemberEmploymentError: "The employment dates you entered overlap with one or more existing employment records for this member. Please review the current records and adjust the dates accordingly.",
                earlierMemberEmploymentError: "It is not permitted to create a new member employment record with a start date earlier than existing entries. Please update the current records accordingly before proceeding.",
            }
        },
        employmentTypes: {
            employment: "Employment",
        }
    },
    beneficiaries: {
        title: "Beneficiaries",
        form: {
            title: "Add a beneficiary",
            firstName: "First name",
            lastName: "Last name",
            percentageSplit: "Percentage split",
            birthdate: "Birth date",
            relationship: "Relationship",
            revocable: "Revocable",
            irrevocable: "Irrevocabe",
            fiduciaryLastName: "Fiduciary's last name",
            fiduciaryFirstName: "Fiduciary's first name",
            fiduciaryBirthdate: "Fiduciary's birth date",
            fiduciaryRelationship: "Fiduciary's relationship",
            isMinor: "This beneficiary is a minor",
        },
        datatable: {
            columns: {
                name: "Name",
                relationship: "Relationship",
                percentageSplit: "Percentage split",
                birthdate: "Birth date",
                actions: "Actions",
                isRevocable: "Revocable",
                isMinor: "Minor",
            },
            actions: {
                edit: "Edit beneficiary",
                includeArchivedBeneficiaries: "Include archived beneficiaries",
                add: "Add beneficiary",
                view: "View beneficiary",
            },
        },
    },
    members: {
        title: "Members",
        selectionsOfMembersForCoverageConfirmation: "Members selected for coverage confirmation generation",
        noMembersSelected: "No member selected",
        memberNotSynced: "This member is not synchronized.",
        nonMemberSync: "This member is not synchronizable.",
        disableSync: "Disable synchronization",
        notTransmittedWarning: 'Members with the name "non transmis" cannot be synchronized',
        onlyCanadianSyncWarning: "Members with a country other than Canada cannot be synchronized",
        completeButNotActivatedWarning: "This member does not have access to the member portal. In order to automatically send him his documents, please change his active coverage to inactive, save the modification, then change the status back to active.",

        activateDisableSyncWarning: "If you disable automatic synchronization for the member, their profile, coverages, and dependents will no longer be synchronized."
            + " The data that has already been synchronized will not be changed.{br}{br}Are you sure you want to proceed?",
        deactivateDisableSyncWarning: "If you enable automatic synchronization for the member, their profile, coverage, and dependent data will be synchronized. "
            + "If the member already has synchronized data, it will be overwritten with the new data.{br}{br}Are you sure you want to proceed?",
        datatable: {
            actions: {
                add: "Add member",
                edit: "Edit member",
                view: "View member",
                includeArchivedMembers: "Include archived members",
                newMembers: "New members",
                includeInactiveMembers: "Include inactivated members",
                coverageConfirmations: "Generate coverage confirmations",
                numberOfMembersSelectedForPeriod: "Members selected for the period: {period} ({membersCount})",
            },
            columns: {
                member: "Member",
                memberIdentifier: "Unique number",
                division: "Division",
                age: "Age",
                status: "Status",
                sync: "Sync.",
                activationStatus: "Activation"
            },
            toolTips: {
                memberNoSync: "The member is not synchronizable.<br/><br/>1- He must not be associated with a client having one of the following statuses: Implementation, Terminated.<br/><br/>2- He must not be archived.<br/><br/>3- His synchronization must be activated.<br/><br/>4- He needs to have a Canadian address.<br/><br/>5- He must at least have one coverage<br/><br/>6- He must not have the name non transmis.",
                syncToolTipWarning: "The member is not synchronized.",
                syncToolTipWarningWithError: "One or more synchronization errors have occurred: {error}",
                syncToolTip: "The member is synchronized.",
                syncToolTipStarted: "The synchronization of the member is in progress."
            }
        },
        payFrequencies: {
            monthly: "Monthly",
            biweekly: "Biweekly",
            weekly: "Weekly",
        },
        form: {
            formChangeWarning: "Warning, your changes in the member profile form were not saved, please use the form's save button.",
            invalidUniqueNumberAlphabet: "The unique number is invalid. Only numeric characters are allowed (0-9).",
            memberIdentifier: "Unique number",
            memberIdentifierRecoveryDate: "Major Code recovery date",
            firstName: "First name",
            lastName: "Last name",
            phoneNumber: "Phone number",
            extensionNumber: "Extension number",
            emailAddress: "Email",
            birthdate: "Birthdate",
            socialInsuranceNumber: "SIN",
            memberGenderType: "Gender",
            languageCode: "Language",
            isSmoker: "Smoker",
            isCanadian: "Canadian or permanent resident",
            provincialHealthNumber: "Provincial health card number",
            importationDate: "Importation date",
            address: "Address",
            city: "City",
            occupation: "Occupation",
            provinceCode: "Province",
            postalCode: "Postal code",
            country: "Country",
            weeklyHours: "Work hours / Week",
            memberPayFrequencyType: "Paie Frequency",
            employeeNumber: "Employee Number",
            isInternational: "International",
            status: "Status",
            persoInfo: "Personal information",
            postalAddress: "Postal address",
            clientInfo: "Corporate client information",
            customEmailAddress: "Email",
            customPhoneNumber: "Phone number",
            customInformation: "Note",
            division: "Division",
            confirmationMessage: "The changes made to this form are automatically saved.",
            confirmationTitle: "Warning!",
            schoolIdentifier: "University number",
            personalIdentifier: "Identification code",
            quarter: "Quarter",
            error: {
                healthCardInfo:
                    "The provincial health card number is mandatory for non-Canadian members; if it is not available, select 'N/D' in the Canadian or Permanent Resident option",
                noClientNumber:
                    "The member creation is currently impossible, as no client number has been provided in the client profile, under 'General informations' section.",
                phoneNumberError: "The phone number must respect the following format: (XXX) XXX-XXXX."
            },
        },
        followUps: {
            activities: "Activities",
            addNote: "Add note",
            editNote: "Edit note",
            form: {
                fileDepositWarning:
                    "You have 5 minutes to upload the file. In case of error, you can save the follow-up then reopen it to upload your files.",
                action: "Action",
                date: "Date",
                user: "User",
                priority: "Priority",
                deadline: "Deadline",
                type: "Type",
                origin: "Origin",
                subType: "Sub type",
                associatedLinks: "Associated link(s)",
                category: "Category",
                generateFollowUp: "Generate a follow-up",
                description: "Description",
                transactionAmount: "Transaction amount (if applicable)",
                followUpInformation: "Follow-up information",
                memberName: "Member name",
                memberIdentifier: "Unique number",
                clientName: "Client",
                preferredContact: "Preferred member contact",
                phone: "Phone",
                email: "Email",
                profileContact: "Client provided contact",
                followUpRecipient: "Send follow-up to",
                followUpClosedOn: "Closed on",
                followUpClosedBy: "Closed by",
                closeFollowUp: "Close follow-up",
                closedFollowUp: "Follow-up closed",
                closeFollowUpReason: "Closure reason",
                comments: {
                    commentLabel: "Add a comment",
                    commentListEmpty: "No comments",
                    commentSubmit: "Send",
                    edit: "Modify a comment",
                    systemComment: "System message",
                },
                emails: {
                    resend: "Resend email",
                    sendEmailTitle: "Resend account activation email",
                    sendEmailMessage:
                        "An email will be resent to the user {userFullName} with his login information to email address {email}. Are you sure you want to confirm this action?",
                    success: {
                        resultTitle: "Account activation email successfully resent",
                        resultMessage:
                            "The account activation email for user {userFullName} has been successfully resent to {email}. Linked follow-up has been updated.",
                    },
                    failure: {
                        resultTitle: "Warning, email resend failed",
                        resultMessage:
                            "The email notification with the user's login information could not be resent to {email}, please check the email address information.",
                    },
                },
                errors: {
                    invalidData: "Data do not match requirements.",
                },
            },
            types: {
                note: "Note",
                incidentFollowUp: "Incident follow-up",
                specialModification: "Special modification",
                passwordManagement: "Password management",
                systemNote: "System note",
            },
            statusTypes: {
                closed: "Closed",
                open: "Open",
                new: "New",
            },
            incidentFollowUpCategories: {
                csQuality: "Customer Service Quality",
                claims: "Claims",
                withdrawal: "Withdrawal",
                planModification: "Plan modifications",
                shiBD: "SHi/Database",
                other: "Other",
            },
            specialModificationCategories: {
                reintegration: "Reintegration",
                withdrawal: "Withdrawal",
                memberAddition: "Member addition",
                dependentAddition: "Dependent addition",
                checkRefund: "Refund by check",
                bankTransferRefund: "Refund by bank transfer",
                checkCancellation: "Check cancellation",
                transferCancellation: "Bank transfer cancellation",
                other: "Other",
            },
            origin: {
                manual: "Manual",
                note: "Note",
                email: "Email",
                phone: "Phone",
                system: "System",
            },
            priorities: {
                urgent: "Urgent",
                twoDays: "48h",
                medium: "Medium",
            },
        },
        member: {
            actions: {
                edit: "Edit custom contact info",
                confirmation: "Generate a coverage confirmation",
                blockFromWithdrawal: "Withdrawal prohibited",
                majorCard: "Generate Major card",
                sendMajorCard: "Generate and send Major card",
                description: "Generate Major card",
                selectAll: "Select All",
                generating: "Generating Major cards",
                error: "An error occurred during the generation of cards",
            },
            errors: {
                noTravelHealthFoundForClient: "The client has no travel or health insurance",
                noHealthOrTravelGuaranteeFoundForMember: "The member {identifier} has no travel or health insurance",
                NoCoverageFound: "The member has no coverage",
                invalidDataType: "The new value does not match the required type",
                majorCardInactiveOrInvalidSyncError: "Client does not qualify for Major card generation. Please refresh the page verify client is not inactive and has valid sync type.",
                majorCardArchivedMemberError: "Client does not qualify for Major card generation. Please refresh the page and verify the member is not archived.",
                majorCardInvalidSyncTypeError: "Client does not qualify for Major card generation. Please refresh the page and verify the client has a valid sync type.",
                majorCardTerminatedClientError: "Client does not qualify for Major card generation. Please refresh the page and verify the client is not terminated."
            },
            pages: {
                profile: "Profile",
                insurance: "Insurance",
                dependents: "Dependents {count, plural, =0 {} other {({count})}}",
                beneficiaries: "Beneficiaries {count, plural, =0 {} other {({count})}}",
                employments: "Employments",
            },
        },
        error: {
            coverageConfirmations: {
                genericError:
                    "An error occurred during coverage confirmation's generation. Please contact the support team.",
                noMemberFound:
                    "No eligible export participants were found with the information provided. Please validate your filters.",
            },
        },
        warning: {
            coverageConfirmations: {
                genericWarning:
                    "Coverage confirmation generation is done but some errors occurred. More details in the generated TXT file available in the downloaded ZIP archive.",
            },
        },
    },
    memberIdentifierConfiguration: {
        form: {
            createRecoveryForm: "Create a <strong>Major Code recovery form</strong>",
            mustUseInstitutionEmailForRecovery: "Force members to use their institutional email",
            recoveryFormMessage: "Form introduction message",
        },
    },
    memberIdentifierRecovery: {
        body: {
            title: "Major Code recovery",
        },
        form: {
            title: "Recovery form to fill out",
            lastName: "Last name",
            firstName: "First name",
            postalCode: "Postal code",
            birthdate: "Date of birth",
            phoneNumber: "Phone number",
            institutionEmail: "Institutional email",
            memberEmail: "Email",
            conditions: {
                byRecovering: "By recovering my Major Code:",
                condition1:
                    "I understand that my Major Code is a unique code that is used to verify my identity each time I submit a claim or contact the Major Plan during the entire duration of my studies at my current educational institution.",
                condition2: "The information provided in this form is complete and accurate.",
                condition3:
                    "By submitting this form, I consent to the information provided being communicated to Major Plan and used by Major Plan for the purpose of administering the group insurance plan and its related services. This information could be shared with insurers, third party service providers and my student association in order to ensure that services are provided effectively.",
                condition4:
                    "I confirm that the information provided is related to my own identity. I understand that if I am requesting retrieval of a Major Code using another person’s information, it could be considered identity fraud and I could be subject to the consequences provided by law relative to these actions.",
            },
            submit: "Submit",
        },
        messages: {
            errors: {
                fieldMissing: "One or more fields are missing. Please verify the data you entered in the form.",
                recoveryFormNotAvailable: "The Major Code recovery form is not available at this time.",
                memberNotFound:
                    "We were unable to recover your Major Code based on the information you provided. Please check the information entered or contact the Major Plan at 1-877-976-2567 or student@planmajor.ca.",
                multipleMembersFound:
                    "More than one Major Code was found based on the information you provided. Please contact the Major Plan at 1-877-976-2567 or student@planmajor.ca.",
                "Server Error":
                    "An error occurred during the operation. Please try again later. If the problem persists, contact an official of your association.",
                recaptchaFailed: "The reCaptcha verification did not work.",
                invalidBirthdate: "You must enter a valid birthdate.",
            },
            success:
                "Your request for your Major Code recovery has been successfully completed! Your Major Code is: {memberIdentifier}.",
            successModalTitle: "Retrieval of Major Code completed",
            successModalBody:
                "<h4>Your Major Code is : {memberIdentifier}</h4>" +
                "<p><br />You will receive an email confirming your Major Code retrieval request in the next few hours.</p>" +
                "<p><br />If you do not receive this confirmation email in the next 24 hours, please contact Major Plan at 1-877-976-2567 or <a href='mailto:student@planmajor.ca'>student@planmajor.ca</a>. Please check your junkmail folder before communicating with us.</p>" +
                "<p><br />Please use your Major Code each time you submit a claim or contact the Major Plan.</p>" +
                "<p><br />In addition to your coverage, the Major Plan gives you access to additional discounts from health and dental professionals. Visit the <a target='_ blank' href='https://planmajor.ca/en/rebate-network/'>Rebate Network</a> section of our website for details.</p>",
        },
    },
    memberFiles: {
        title: "File Generations",
        dataTable: {
            name: "Member",
            coverageDate: "Coverage date",
            generationDate: "Generation date",
            error: "Error",
            files: "Files",
            majorCard: "Major card",
            status: "Status",
            selectAll: "Select all",
            regenerateButton: "Regenerate Selected",
            statuses: {
                failure: "Failure",
                started: "Started"
            },
            toasts: {
                regenerateInitiated: "Files regeneration initiated for selected members. Please wait a few moments.",
                regenerateInitiatedMajorCard: "Major card generation initiated for selected member(s). In case of problem, the generation will be accessible through the client's Failed File Generations page.",
                regenerateInitiatedMajorCardError: "Major card Generation failed: All selected members are either archived, missing active coverage, or do not have an email address.",
                regenerateInitiatedMajorCardErrorSingular: "Major card generation failed: This member is either archived, missing active coverage, or does not have an email address.",
                partialRegenerateInitiatedMajorCardError: "Partial Major card generation initiated. Certain selected members are either archived, do not have active coverage, or do not have an email address:{br}",
                regenerateError: "An error occurred while initiating file regeneration. Please try again.",
                regenerateMajorCardError: "An error occurred while initiating file generation. Please try again.",
                allMembersArchivedError: "All selected members are archived or not found and cannot have their files regenerated.",
                allMembersNonEligibleError: "All selected members already have successful recent file regenerations and cannot have their files regenerated again."
            },
            errors: {
                noCoverageFound: "The member has no active coverage",
                noHealthOrTravelGuarantee: "The member has no health or travel guarantee",
                technicalError: "An error occurred. Please contact support. More information: {error}",
                timeout: "The file could not be generated in time.",
            },
            noFileMessage: "No file defined for this member"
        }
    },
    messages: {
        title: "Messages",
        datatable: {
            actions: {
                add: "Add message",
                edit: "Edit message",
                view: "View message",
            },
            columns: {
                date: "Date",
                createdBy: "Created By",
                message: "Message",
                read: "Read",
                unread: "Unread",
            },
        },
        form: {
            message: "Message",
        },
    },
    passwordForm: {
        passwordMessage: "Password reset",
        passwordMessageBody:
            "<p>A password reset email will be sent to <a target='_blank'>{emailAddress}</a></p>" +
            "<p>If the email address is incorrect, please contact your account manager or support</p>" +
            "<p>Would you like to continue?</p>",
        changePassword: "Change password",
    },
    downloadsModal: {
        title: "Ongoing downloads",
        noDownloads: "No current downloads.",
        success: "Downloaded successfully: {identifier}",
        error: "Download error: {identifier} {message}",
    },
    publicPage: {
        header: {
            majorPlan: "The Major Group",
            studentSolution: "The student solution",
            yourAssociation: "Your association",
        },
        404: {
            title: "404",
            text: "The requested page does not exist.",
        },
        footer: {
            copyrights:
                "&copy; <a target='_blank' href='http://www.groupemajor.ca/en'>Major Group</a>. All rights reserved",
            contactEmail: "<span>Contact us</span><a href='mailto:etudiant@planmajor.ca'>etudiant@planmajor.ca</a>",
            contactPhone: "<span>Toll free</span><a href='tel:+18779762567'>1.877.976.2567</a>",
        },
    },
    salesTaxes: {
        title: "Tax management",
        unit: "%",
        applicablePeriod: "Applicable period",
        types: {
            hst: "GST / HST",
            pst: "PST / QST",
            insurance: "Insurances",
            surtax: "Surtax",
        },
        editTaxWarning: "Only the present tax values are subject to change.",
    },
    search: {
        datatables: {
            clients: {
                division: "Division",
            },
            members: {
                client: "Client",
                name: "Name",
            },
        },
        noResults: "Your search did not yield any results.",
        placeHolder: "Unique number, name, client, numeric phone number e.g. 5141234567, birthdate e.g. 31/01/2001",
        title: "Search results",
    },
    status: {
        active: "Active",
        activeComplete: "Active complete",
        activePartial: "Active partial",
        inactive: "Inactive",
        archived: "Archived",
        unarchived: "Unarchived",
        incomplete: "Incomplete",
        canceled: "Cancelled",
        generated: "Generated",
        generating: "Generating",
        implementation: "Implementation",
        terminated: "Terminated",
        emailVerified: "Email verified",
        emailNotVerified: "Email not verified",
    },
    suppliersReports: {
        actions: {
            download: "Download",
        },
        datatable: {
            columns: {
                month: "Month",
                size: "Size",
                actions: "Actions",
            },
        },
    },
    validation: {
        archiveForbidden: "It is not allowed to modify an archived data",
        array: "Something went wrong",
        atLeastOne: "You must select at least one element",
        emailRegex: "The text field must be a valid email format without spaces and accents",
        fileNameContainsSubString: "The filename must contain {ruleValue}",
        fileOfExtension: "Uploaded file must be of extension {ruleValue}",
        legalTextCheckBoxValidation: "The box must be ticked to submit the form",
        cityRegex: "This field must contain alphabetical characters only",
        fileOfSignature: "Uploaded file doesn't match expected file signature",
        isRequired: "Field must contain a value",
        isRequiredFile: "No file was selected",
        isRequiredTrim: "Field must contain a value",
        isRequiredTrimShort: "Required Value",
        maxLength: "Field must have a maximum length of {ruleValue}",
        minLength: "Field must have a minimum length of {ruleValue}",
        minValue: "Field must have a minimum value of {ruleValue}",
        mustMatch: "Field must have the same value as {ruleValue}",
        mutuallyExclusiveWith: "Cannot be selected at the same time as {other}",
        noSpaces: "Field must not contain whitespaces",
        noSpacesBeginning: "Field must not start with a whitespace",
        noSpacesEnd: "Field must not end with a whitespace",
        onlyNumerical: "The field can only contain numbers.",
        stringSameCharacters: "The field cannot contain a sequence of the same value",
        regex: "Field must be in the correct format",
        websiteRegex: "Please enter a valid Website URL (e.g. http://www.example.com)",
        float: "Field must be a number or decimal number",
        higherThan: "The value entered must be higher than {ruleValue}",
        lowerThan: "The value entered must be lower than {ruleValue}",
        EqualOrGreaterThanStartDate: "Must be greater than or equal to start date",
        cannotExceed100: "The value cannot exceed 100",
        valueBetween: "The value must be between {minimum} and {maximum}",
        memberValidation: {
            noMemberIdentifier: "The client number is required to create a member with an automatic identifier option.",
            noClientNumber:
                "The member creation is currently impossible, as no client number has been provided in the client profile, under 'General informations' section.",
        },
        clientFieldValidation: {
            validationInProgress: "Validation in progress...",
            attention: "Attention!",
            generalSuccessMessage: "The client {client} was successfully created.",
            tedDesjardinsValidationMemberConfig: "The configuration of member identifiers must be automatic for clients having the TED Desjardins synchronization option.",
            tedDesjardinsValidationMemberIdentifierType: "The member identifier length must be personalised for clients having the TED Desjardins synchronization option. (must have a length of 9)",
            tedDesjardinsValidationMemberIdentifierLength: "The member identifier length must be 9 for clients having the TED Desjardins synchronization option.",
            clientChangeStatusSuccessTitle: "The client is ready to go {status}",
            clientActivePassageMessage:
                "With the client activation, member, class and client coverages starting before {coverageDate} were automatically reconfigured to begin on {coverageDate}. Attention, those starting after {coverageDate} have not been modified.",
            clientChangeStatusValidationSuccess:
                "The information required for the client to go {status} has been entered.",
            creationAction: "creation",
            modifyAction: "modification",
            unknownAPIError: "An error has occurred.",
            clientTransitionError:
                "A status transition for this client is already in progress, please try again in a few minutes.",
            clientChangeStatusValidationError:
                "Several pieces of information are missing to complete the status change.{br}Please fill in the information below: {br} {br}",
            generalErrorMessage:
                "Attention, several informations are missing for the client {actionType}. {br}Please fill in the information below: {br} {br}",
            clientNumberMandatoryWarn: "The client number is mandatory for all active clients.",
            invoiceMEVError: "Unable to generate the TEMPLATE invoice, the following information is missing:{br}",
            clientNumberWarnForIdentifier: "The client number is mandatory for automatic member identifiers.",
            emptyMemberIdentifierTypeWarn: "The member identifier type is mandatory.",
            emptyInitialLengthWarn: "The length is mandatory for the automatic member identifier.",
            invalidMemberIdentifierLength: "The initial length for member identifier must be at least 6.",
            missingClientNumberForAutomaticIdentifier:
                "Attention, the client number is mandatory for an automatic generation of the members certificate number and should be provided before creating the first member.",
            activeSuccess: "The client {client} has been successfully changed to active status",
            coverageWarning:
                "Attention, by making this customer active, he will be included in the next billing period ({nextBP}).{br}However, its coverage start date is in {coverageMonth}.{br}All invoices before the coverage start date will be generated at 0$.{br}Are you sure you want to continue?",
            serverErrors: {
                emptyNameField: "Usual name",
                emptyFullNameField: "Full name",
                emptyDesignatorField: "Acronym",
                emptyAddressField: "Address",
                emptyCityField: "City",
                emptyProvinceCodeField: "Province",
                emptyPostalCodeField: "Postal Code",
                emptyBusinessAccountTypeField: "Account type",
                emptySyncTypeField: "Choice of API synchronization",
                emptyBlocIdField: "Bloc",
                emptyBillingPeriodTypeField: "Billing Periods",
                emptyClientStatusTypeField: "Status",
                emptyMemberIdentifierOptionField: "Unique number configuration for members",
                emptyStartDateField: "Coverage Period - Start date",
                emptyEndDateField: "Coverage Period - End Date",
                emptyInitialLength: "Length for unique number",
                clientNumberMandatory: "Client number",
                emptyAccountManagerIdField: "An account manager user associated with this client",
                emptyPolicyNumber: "Missing policy number for the following guarantee(s): {}",
                badlyConfiguredPolicyNumber: "Policy number invalid for the following guarantee(s): {}",
                misconfiguredManualBillingPeriods: "Missing invoicing configuration for billing period(s): {}",
                emptyClassClientCoverage: "Class client coverages",
                emptyAdminContactFirstNameField: "Administrative contact first name",
                emptyAdminContactLastNameField: "Administrative contact last name",
                emptyAdminContactJobPositionField: "Administrative contact job position",
                emptyAdminContactPhoneNumberField: "Administrative contact phone number",
                emptyAdminContactEmailAddressField: "Administrative contact email address",
                emptyAdminContactLanguageCodeField: "Administrative contact language",
                emptyClientNumberField: "Client number (Telus or Desjardins)",
                emptyPaymentTypeField: "Payment mode",
                emptyAcombaNumberField: "Client number (ACOMBA)",
                emptyAcombaProjectNumberField: "Project number",
                emptyIsAutomaticMemberIdentifierField: "Configuration of automatic member identifier",
                emptyMemberIdentifierTypeField: "Members unique number length",
                emptymemberIdentifierInitialLengthField: "Member identifier length",
                emptyMemberIdentifierInitialLengthCustomField: "Member identifier length between 6 and 15 characters",
                emptyAccountManagerField: "An account manager user associated with this client",
                hasGenericAccountManager: "Client has generic account manager",
                emptyBillingPeriod: "Billing period",
                emptyInvoice: "Template invoice with a total amount greater than zero",
                emptyClass: "Class",
                emptyDivision: "Division",
                emptyExternalDivisionNumber: "Telus or Desjardins division number for the division(s): {}",
                emptyExternalClassNumber: "Telus or Desjardins class number for the class(es): {}",
                emptyClientCoverage: "Client coverage",
                emptyPlanAdministrator: "A plan administrator user associated with this client",
                invalidTemplateInvoice: "Valid template invoice having at least one active and unarchived member",
                emptyServiceRepresentativeIdField: "A service representative user associated with this client",
                emptyCreditsInvoiceCountField: "Number of adjustment invoices",
                emptyCreditsInvoiceFrequencyField: "Frequency of adjustment invoices",
                billingPeriodDateError:
                    "A billing period is still ongoing, unable to schedule the client last active date",
            },
        },
        customMessages: {
            alphanumeric: "Only alphanumeric characters are allowed",
            numeric: "Only numeric characters are allowed",
            clientError: "An error has occurred. Please try again in a few moments. If the problem persists, please contact support.",
            serverErrors: {
                duplicateUsername: "The username entered already exists in the database",
                userCreationError: "An error has occurred during user creation. Please contact the support.",
                buAssociatedError:
                    "An error has occurred while creating links between the user and his business unit. Please contact support.",
                unauthorizedClientError:
                    "An error has occurred while creating links between the user and given client. Please select a client from the same business unit or contact support.",
                passwordLinkError:
                    "The user has been created, however there was a problem while sending the link to create the password. Please contact support.",
                clientNumberError: "The client number cannot be modified if the client already has a member",
                existingClientConfigurationError: "This client number already exists for another client but the associated configuration is incompatible with DESJARDINS synchronization mode.",
                duplicateBlocName: "The bloc name entered already exists in the database",
                duplicateGroupName: "A group with this name already exists. Please choose another name",
                duplicateClassName: "The class name entered already exists in the database",
                duplicateClientName: "The client name entered already exists in the database",
                duplicateDesignator: "The client acronym entered already exists in the database",
                duplicateDivisionName: "The division name entered already exists in the database",
                duplicateMemberIdentifier: "The unique number entered already exists in the database",
                dateRequired: "The coverage period is mandatory for corporate model",
                accountTypeRequired: "Account type is required",
                businessAccountTypeUneditable: "Business account type cannot be modified",
                genericError: "An unknown error has occurred. Please try again later",
                driving_cannot_depend_on: "A driving mandatory dependent guarantee cannot be defined as dependent on another guarantee",
                depends_on_cannot_be_driving: "A guarantee that depends on another cannot be defined as a driving mandatory dependent guarantee",
                wrongAuthorizationCode: "Authorization code is invalid",
                wrongPassword: "Password is invalid",
                clientNumberRequired: "The client number is mandatory for group major clients",
                clientNumberMandatory: "The client number is mandatory for group major clients",
                clientNumberUneditable: "The client number cannot be modified for the group major clients",
                memberIdentifierConfigurationUneditable: "Member identifier type cannot be modified",
                internalContactsConfigurationUneditable: "Internal contacts cannot be modified for inactive or terminated clients.",
                billingPeriodCreationError: "The creation of the new billing period failed",
                billingPeriodDelayCriteriaError: "The billing period is ineligible for delay",
                noSymbolsInClientNumber: "The client number cannot have symbols.",
                manualMemberIdentifierType: "Due to the manual method used to generate the member's certificate number, this existing client number (TELUS or Desjardins) cannot be reused.",
                noAlphabetInClientNumber: "The client number cannot have letters for group major corporate clients",
                invalidClientBlocError:
                    "It is forbidden to change a non-billable bloc. If you want to do this, please create a new client.",
                noHealthOrTravelGuaranteeFoundForMember: "The member has no travel or health insurance",
                generic: "Something went wrong.",
                noTravelHealthFoundForClient: "The client has no travel or health insurance",
                NoCoverageFound: "The member has no coverage",
                retroactiveFetchError:
                    "An error occurred while fetching the retroactive limit modification date. Please contact support.",
                mfaPreferenceUpdateError:
                    "An error occurred while updating mfa code reception preference. Please contact support.",
                invalidNewPasswordError: "Invalid password.",
                forbiddenSimultaneousDependentAndMandatoryGuarantee: "A guarantee cannot be dependent and a mandatory dependent guarantee at the same time."
            },
            coverageStartDate: "The coverage cannot start before or on the same day as the previous one",
            emailAddressRegex: "Email should be formatted as: example@email.com",
            emailAddressMatch: "Emails do not match",
            postalCodeRegex: "Postal Code should be formatted as: A1A1A1",
            startDate: "The start date must be before the end date",
            endDate: "The end date must be after the start date",
            birthdate: "Disability start date cannot be before birthdate",
            startDateAfterClientCreation: "The client's coverage cannot start earlier than six months from now.",
            minimumDate: "The date entered must be later than the {ruleValue, date, medium}",
            banking: {
                transitNumber: "The transit number must contain 5 digits",
                institutionNumber: "The institution number must contain 3 digits",
                accountNumber: "The account number must contain 5 to 12 digits",
                accountNumberSevenDigit: "Your account number must contain 7 digits",
                bankCheckDigit: "The bank check digit must contain 1 digit",
                bankAccountOwnerName: "The bank account owner name must contain a name",
            },
            noActiveGuarantees: "You must have at least one active guarantee",
            noBillingPeriods: "You must have at least one billing period configured",
            recaptchaFailed: "The reCaptcha check did not work.",
            recaptcha: "Please prove you are not a robot",
            acceptCondition: "You must agree to this condition",
            passwordRegex: "Your password does not fulfill the requirements",
            passwordRules:
                "<div>The password must :" +
                "<ul>" +
                "<li>be at least 12 characters long;</li>" +
                "<li>contain at least one lower case letter;</li>" +
                "<li>contain at least one upper case letter;</li>" +
                "<li>contain at least one special symbol;</li>" +
                "<li>contain at least one number.</li>" +
                "</ul>" +
                "</div>",
            passwordWebsite:
                "https://www.cyber.gc.ca/en/guidance/user-authentication-guidance-information-technology-systems-itsp30031-v3#a21",
            passwordWebsiteString: "Government website for password management recommendations",
        },
    },
    invoicingConfig: {
        successToast: "Data was saved successfully",
        form: {
            title: "Adjustment invoice configuration",
            submit: "Submit",
            creditsInvoiceFrequency: "Frequency of adjustment invoices (in months)",
            creditsInvoiceCount: "Number of adjustment invoices",
            description:
                "This page allows you to configure the parameters for generating adjustment invoices. For each billing period, these values will be entered and can be modified. \
            The legal deadline for taking into account a billing period adjustments is {year} years. You must enter the monthly frequency for generating adjustment invoices over these {year} years.",
            calculatedInformation:
                "An adjustment invoice will be generated every {frequency} month(s).<br />For each billing period {invoiceCount} adjustment invoices will be generated over {year} years.",
        },
    },
    clientContacts: {
        successStrategicToast: "Strategic contacts have been saved successfully",
        successOperationalToast: "Operational contacts have been saved successfully",
        archiveToast: "Client contact {archivedName} was deleted successfully",
        archiveConfirmationMessage: "Are you sure you would like to delete contact {archivedName} ?",
        form: {
            operationalContact: {
                title: "Operational contacts",
                save: "Save",
                internalContacts: "Internal contacts",
                emailAddress: "Email address",
                firstName: "First name",
                lastName: "Last name",
                phoneNumber: "Phone number",
                contactTitle: "Title",
                phoneExtension: "Extension",
                mainTitle: "Main contact",
                adminTitle: "Administrative contact",
                language: "Contact language",
                accountManager: "Account Manager",
                serviceRepresentative: "Service Representative",
                enterPhoneNumber: "Please enter a valid phone number",
                extensionNumber: "Extension number",
                phoneNumberFormatError: "The phone number must respect the following format: (XXX) XXX-XXXX."
            },
            strategicContact: {
                title: "Strategic contacts",
                contact: "Contact {contactIndex}",
                save: "Save",
                emailAddress: "Email address",
                firstName: "First name",
                lastName: "Last name",
                phoneNumber: "Phone number",
                contactTitle: "Title",
                language: "Contact language",
                role: "Role",
                linkedin: "LinkedIn",
                primaryStrategicContact: "Primary strategic contact",
                linkedInWebsiteError: "The LinkedIn URL format is invalid.",
                linkedInWebsiteRegex: "Invalid LinkedIn address. Accepted format: https://linkedin.com/in/profile-name{br}",
                linkedInWebsiteRegexList:
                    "<ul>" +
                    "<li>3 characters minimum for the <u>profile-name</u></li>" +
                    "<li>Special characters allowed for the <u>profile-name</u>: ~%-</li>" +
                    "</ul>",
                comment: "Comment",
                notePlaceholder: "Enter your comment here",
                noteLimitError: "Entries are limited to 500 characters.",
                roles: {
                    executive: "Executive",
                    finance: "Finance",
                    hr: "Human Resources",
                    other: "Other",
                    select: "Select..."
                },
                mainStrategicMessage: "Each client can have only one primary strategic contact",
            },
        },
    },
    personalData: {
        form: {
            title: "Review of personal information",
            memberIdentifier: "Certificate number",
            email: "Email",
            confirmEmail: "Confirm your email",
            verifyInformation: "Please verify the following information:",
            informationMessage:
                "If the information is incorrect, you can update it, your file will be automatically updated",
            personalInfoTitle: "Personal information",
            postalInfoTitle: "Postal address",
            firstName: "First name",
            lastName: "Last name",
            phoneNumber: "Phone number",
            birthDate: "Birth date",
            gender: "Gender",
            language: "Language",
            address: "Address",
            city: "City",
            country: "Country",
            province: "Province",
            postalCode: "Postal code",
            noFormAvailable: "No forms are available for this client.",
            conditions: "Conditions",
            definedConditions:
                "To fill out this form, you must be a student member of the student association whose acronym/name appears at the top of the form. <br /><br />" +
                "The information provided must be mine and not that of another person. <br /><br />" +
                "If you are a college student, make sure you are on the correct form based on your type of studies (regular program - RP / continuing education - CE).",
            readInfoWarn:
                "You must use this page to check your group insurance data. Please read the information before completing the form.",
            procedure: "Procedure",
            definedProcedure:
                "Your certificate number must correspond to the one used by your student association.<br /><br />" +
                "For more information on your certificate number, please refer to: <a href='https://planmajor.ca/en/certificate-number/'>https://planmajor.ca/en/certificate-number/ </a> <br /><br />" +
                "Fill out this form, ensuring that you enter the correct information. If the information entered is incorrect, it will significantly impact the service you receive from Major Plan. <br /><br />" +
                "Make sure to click the <i>submit</i> button and confirm the receipt of the confirmation email for form submission.<br /><br />" +
                "After submitting the form, there may be a waiting period of up to 7 business days for your insurance file to become active. During this period, it is normal that you cannot create an account on the mobile application or web portal or submit claims directly to the dental or pharmacy office. <br /><br />" +
                "Contact Major Plan if you do not receive your confirmation email within 24 hours of submitting the form (check your spam or junk folder).",
            formToFillTitle: "Request form to fill",
            submitBtn: "Submit",
            infoAboutSubmission:
                "In order to complete the personal information control form, you must go through the secure access procedure. A verification code will be sent to your email address to verify your identity.",
            verificationCodePopUp:
                "You will receive an email with a verification code in the next few minutes. This code is valid for 30 minutes. Following this period of time, a second code will be sent to you. Please enter this code to continue.",
            verificationCodeModalTitle: "Information",
            verificationCodeLabel: "Verification code",
            attention: "Attention!",
            unknownMemberErr:
                "<span>Your profile was not found, please check your information. If your information is correct, please contact Major Plan's customer service at <a href='mailto:etudiant@planmajor.ca'>etudiant@planmajor.ca</a>.<span>",
            infoError: "An error has occurred, please verify your information.",
            retryCheckCode: "I have not received the code -> Resend",
            pleaseVerify: "Please check the following information: ",
            pleaseVerifyInfo:
                "If this information is incorrect, you can modify it, your profile will be automatically updated.",
            formEndMessage:
                "You will receive an email confirming that your personal information has been updated within the next few hours. If you have not received this confirmation within the next 24 hours, please contact Plan Major at 1-877-976-2567 or student@planmajor.ca",
            formEndTitle: "Form completed",
            checkCodeValidity:
                "This code is valid for {time} minutes. After this time, you will need to request a new one.",
            checkCodeTimeError: "The member code was created less than 3 minutes ago. Please try again later.",
            legalText:
                "I confirm that the information provided is true, and that in the event of an error or omission on my part, it could compromise the quality of the service offered, or even render the provision of Major Plan's services impossible.",
            legalTextIdentity:
                "I confirm that I am indeed the person for whom I am providing the information, and if otherwise, it could be considered identity theft. Major Plan, the student association, or the concerned individual may take legal action against me.",
            legalTextDataUsage:
                "I confirm that I understand and agree that the information provided in this online form will be used internally by the Major Plan team for the proper functioning of the services offered, and that my information may be shared in writing with insurers or other service providers included in the service package chosen by my student association. My student association or institution may also have access to this information. If I wish to withdraw this consent, I must communicate with Plan Major in writing.",
            legalTextDelay:
                "I understand that there may be a period of up to 7 business days between the time I submit this form and when my insurance file becomes active. During this period, it is normal that I am unable to create an account on the mobile application or web portal and submit claims directly to the dental or pharmacy office.",
        },
    },
    withdrawal: {
        body: {
            title: "Withdrawal application from the insurance plan",
            introduction:
                "<p>You must use this page to complete your withdrawal request from the insurance plan. Read the instructions before filling out the form.</p>",
            conditions:
                "<h3>Terms and conditions</h3>" +
                "<p>Your request for withdrawal must be made within the prescribed deadline.  You will not have another opportunity to use your automatic withdrawal option.</p>" +
                "<p>You must have the mention “Group Insurance” on your institutional invoice.</p>",
            conditionsPerm:
                "<p>The permanent withdrawal is effective for all the duration of your studies (all cycles included), whether your studies are continuous or interrupted.  The insurance plan offers some non-automatic terms of reinstatement.</p>",
            procedure:
                "<h3>Procedures</h3>" +
                "<p>To withdraw from the insurance plan, you must follow the following procedure:</p>" +
                "<ul>" +
                "<li>Fill out the web form below and send it.</li>" +
                "<li>Check out your email inbox within the hours of sending the form.  You will receive an email confirming that your request has been registered.  <strong class='emphasis'>Keep this email</strong>.</li>" +
                "</ul>",
            withdrawalClosed: "The modification and withdrawal period is currently closed.",
        },
        form: {
            title: "Withdrawal form to fill out",
            memberIdentifier: "Certificate number",
            institutionEmail: "Institution email",
            memberEmail: "Email",
            confirmEmail: "Confirm email",
            permanentWithdrawal: "I would like to withdraw permanently from the insurance plan",
            annualWithdrawal: "I would like to withdraw annually from the insurance plan",
            sessionWithdrawal: "I would like to withdraw sessionally from the insurance plan",
            conditions: {
                byWithdrawing: "By withdrawing from the plan:",
                haveRead:
                    "I confirm that I read the enclosed documentation on this site regarding the collective insurance plan;",
                acceptance:
                    "I accept the withdrawal procedure and I understand that <strong class='emphasis'>the confirmation email shall constitute the only acceptable proof</strong>;",
                legalUnbinding:
                    "I release Major Plan, my student association, the insurance companies (if applicable), as well as any other party concerned, from all liability for damages or claims;",
                understanding:
                    "I understand that by withdrawing from the plan on a permanent basis, I will not be able to re-enter the plan unless I meet the criteria and conditions established by my student association, which may change without notice.",
                withdrawFromTheRegime:
                    "By opting out of the plan, I consent to the sharing of my personal informations (first name, last name, date of birth, ID number and address) with my educational institution and student association in order to confirm my withdrawal from the service, if necessary.",
                correctBankInfo:
                    "I certify that the bank details provided are correct, I release Major Plan from all liability in the event that these are incorrect and I understand that Major Plan could apply administrative fees for the reissuance of a payment.",
                bankAccountOwner:
                    "I confirm that I am the primary account holder of the bank account and that I am the withdrawing member of the insurance plan.",
            },
            submit: "Submit",
            verificationCode: "Verification code",
            refundWarning:
                "*If you choose to be reimbursed for the insurance by cheque, or if your bank information is inaccurate, a $6 fee will be charged to you. This will be deducted from the amount to be refunded to you.",
            refundCheck: "By Check",
            refundDeposit: "Direct Deposit",
            checkSpecimenTooltip:
                "Here is an example of a check specimen, including the information you must enter in the required fields. Information for Desjardins members : your account number is composed of 7 digits, the check digit corresponds to the last digit of your account number.",
            refundFields: "Bank account information",
            refundAddress:
                "<p>" +
                "<strong>The check will be sent to the following address:</strong>" +
                "<br />{address}" +
                "<br />{city} {postalCode}" +
                "<br />{province} {country}" +
                "<br /><br /><em>If the address is not correct, please contact the Major Plan.</em>" +
                "</p>",
            noLocalAddress: "<p><em>You do not have an address in the file, please contact the Major Plan.</em></p>",
            transitNumber: "Transit number",
            institutionNumber: "Institution Number",
            accountNumber: "Account Number",
            checkDigit: "Check digit",
            bankAccountOwnerName: "Bank account holder",
            withdrawalInformationTitle: "Withdrawal type",
            withdrawalInformationTypes: "Choice of withdrawal type:",
            withdrawalInformationPermanent: "Permanent withdrawal will permanently withdraw you from the plan.",
            withdrawalInformationAnnual:
                "Annual withdrawal will remove you from the plan for the entire current academic year.",
            withdrawalInformationSession:
                "Withdrawal by session will withdraw you from the plan for the current session [{billingPeriod}] . If you are still a student at the time of the next session, you will have to opt out again if you do not wish to retain coverage at that time.",
        },
        messages: {
            errors: {
                blockedFromWithdrawal:
                    "Your opt-out is currently unavailable. Please contact the Major Plan for more information.",
                unpaidCoverage:
                    "Your opt-out is currently unavailable. Please contact the Major Plan for more information.",
                alreadyWithdrawn:
                    "You have already withdrawn from your plan.",
                relatedCoverageStillActive:
                    "You can not withdraw because your withdrawal period was at the previous session.",
                invalidMemberIdentifier:
                    "The ID number you entered is invalid. Be sure to use your institutional number.",
                inactiveCoverage: "You are not covered by any component of the insurance plan.",
                noCoverageFound: "You are not covered by any component of the insurance plan.",
                noGuaranteeFound: "You are not covered by any component of the insurance plan.",
                submitFailed:
                    "An error occurred during the operation. Please try again later. If the problem persists, contact an official of your association.",
                "Server Error":
                    "An error occurred during the operation. Please try again later. If the problem persists, contact an official of your association.",
                wrongVerificationCode: "Your verification number is invalid.",
                recaptchaFailed: "The reCaptcha check did not work.",
                bankAccountOwnerName: "You have not filled in the account holder field.",
            },
            informationModalTitle: "Additional information",
            success: "Your request for withdrawal has been successfully completed!",
            successModalTitle: "Opt-out complete",
            successModalBody:
                "<p>You will receive a confirmation e-mail within the next few hours for your opt-out.</p>" +
                "<p><br />Please keep this email until you complete your studies. <strong>This e-mail is proof that you have completed the opt-out process and that you have opted-out</strong>.</p>" +
                "<p><br />If you have not received this confirmation within the next 24 hours, please contact the Major Plan at 1-877-976-2567 or student@planmajor.ca.</p>" +
                "<p><br />Before contacting the Major Plan, be sure to check your junk e-mails.</p>",
            validation: {
                confirmInstitutionalEmail: "You must input your institutional email address",
                refundMethod: "You must choose a refund method",
                verificationCode: "You must fill in your verification code",
                withdrawalMethod: "You must select a withdrawal method",
                withdrawalSelection: "You must select at least one coverage",
                acceptCondition: "You must agree to this condition",
            },
        },
    },
    withdrawalConfiguration: {
        title: "Withdrawal configuration (if applicable)",
        supportedWithdrawals: "Supported withdrawals",
        datatable: {
            actions: {
                add: "Add a coverage group",
                edit: "Edit coverage group",
                includeArchivedCoverageGroups: "Include archived coverage groups",
            },
            columns: {
                name: "Group name",
                guarantees: "Coverages",
            },
        },
        email: {
            view: "View email",
        },
        form: {
            createWithdrawalForm:
                "Create a <strong>withdrawal form</strong> for each new withdrawal periods (withdrawal handled by Major Group)",
            includeCodeAuthentication: "Include a <strong>verification code</strong> authentication",
            refuteWithdrawalForUnpaidCoverages: "Refute withdrawal for students who have not paid the tuition fees",
            requireBankingInformation: "Support refund (members will be asked to choose their refund method)",
            mustUseInstitutionEmailForWithdrawal: "Force members to use their institutional email",
            hasWithdrawalFormMessage: "Display a custom message above the form",
            hasWithdrawalPopupMessage: "Display an information popup after the identification number is verified",
            withdrawalPopupTitle: "Information popup title",
            withdrawalPopupMessage: "Information popup content",
            hasWithdrawalRedirectButton: "Configure a redirection button",
            redirectButtonMessage: "Button introduction message",
            redirectButtonLabel: "Button text",
            redirectButtonURL: "Button URL",
            withdrawalFormMessage: "Message",
            allowPermanentDeactivation: "Permanent withdrawal",
            allowYearlyDeactivation: "Yearly withdrawal",
            allowSessionallyDeactivation: "Withdrawal by session",
            permanentDeactivationEmailTemplate: "Permanent withdrawal email",
            yearlyDeactivationEmailTemplate: "Yearly withdrawal email",
            sessionallyDeactivationEmailTemplate: "Withdrawal by session email",
            coverageGroupDeactivationEmailTemplate: "Coverage group withdrawal email",
            name: "Group name",
            guarantees: "Guarantees",
            emailMessage: "Group withdrawal email",
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/intl/en-CA.js